// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/wallpaper2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,800;1,300;1,400;1,500;1,600;1,800&family=Roboto&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-box-shadow {
  box-shadow: none !important;
}

.center {
  margin: auto;
  width: 50%;
  padding: 10px;
  text-align: center;
}

.MuiDrawer-paper {
  background-color: var(--mui-palette-primary-main) !important;
}
.MuiDrawer-paper span, .MuiDrawer-paper p, .MuiDrawer-paper svg {
  color: white;
}

.description {
  color: rgba(0, 0, 0, 0.5);
}

.content-container {
  padding: 1rem 5rem;
}
.content-container .divider {
  margin-top: 1rem;
}
.content-container .main-content-wrapper {
  padding: 3rem 0;
}

html {
  font-size: 1.25rem;
}
html span {
  color: "#ffffff";
}
html span, html p, html input, html h1, html h2, html h3, html h4, html h5, html h6, html button {
  font-family: "Mulish", sans-serif !important;
  font-weight: 400;
}
html a, html button {
  cursor: pointer;
}
html .container {
  padding: 0.3125rem 0.625rem;
}
html input[type=number]::-webkit-inner-spin-button,
html input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
html input[type=number] {
  -moz-appearance: textfield;
}

@media (max-width: 480px) {
  html {
    font-size: 1.125rem;
  }
}
@media (min-width: 480px) and (max-width: 600px) {
  html {
    font-size: 1.125rem;
  }
}
@media (min-width: 600px) and (max-width: 800px) {
  html {
    font-size: 1.125rem;
  }
}
@media (min-width: 800px) and (max-width: 1000px) {
  html {
    font-size: 1.125rem;
  }
}
.transparent-bar p, .transparent-bar span, .transparent-bar button {
  color: black;
}
.transparent-bar .MuiToolbar-root .MuiBox-root {
  margin-left: 15px;
}
.transparent-bar .MuiToolbar-root .MuiBox-root button {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 6px 16px;
  text-transform: capitalize;
  font-weight: 600;
}
.transparent-bar .logo-wrapper {
  height: 100%;
  margin-right: 1rem;
}
.transparent-bar .logo-wrapper img {
  height: 3rem;
  margin-top: 0.5rem;
}
.transparent-bar .action-btn {
  color: white;
}

.search-navbar {
  padding: 0.3rem 3rem;
}
.search-navbar .MuiToolbar-root {
  align-items: center;
}
.search-navbar .logo-wrapper {
  height: 100%;
  margin-right: 1rem;
}
.search-navbar .logo-wrapper img {
  height: 1.5rem;
}
.search-navbar .search-bar {
  width: 40% !important;
  align-items: center;
}
.search-navbar .search-bar .search-input {
  width: 100%;
}
.search-navbar .search-bar .search-input input {
  width: 100%;
}
@media only screen and (max-width: 899px) {
  .search-navbar .search-bar {
    width: 100% !important;
  }
}
.search-navbar .logo-title {
  font-size: 1.5rem;
}

.drawer-wrapper-right .MuiDrawer-paper {
  background-color: white !important;
}
.drawer-wrapper-right .MuiDrawer-paper .action-wrapper {
  display: flex;
  justify-content: center;
}
.drawer-wrapper-right span {
  color: black;
}

@media (min-width: 0px) and (orientation: landscape) {
  .MuiToolbar-root {
    min-height: 64px !important;
  }
}
@media only screen and (max-width: 899px) {
  .search-navbar {
    padding: 0.3rem 1rem;
  }
}
.seconday-appbar {
  background-color: var(--mui-palette-secondary-main);
  padding: 0.5rem 4rem !important;
  font-size: 0;
  display: flex;
}
.seconday-appbar span, .seconday-appbar p, .seconday-appbar button {
  text-transform: none;
}
.seconday-appbar svg {
  color: white;
}
.seconday-appbar .MuiButtonBase-root:not(:last-child) {
  margin-right: 1rem;
}

@media only screen and (max-width: 600px) {
  .seconday-appbar {
    padding: 0 !important;
    display: block;
  }
}
.drawer-wrapper .MuiDrawer-paper {
  height: 100% !important;
}

.side-filter-wrapper .filter-wrapper {
  width: 80%;
}
.side-filter-wrapper .filter-wrapper .title {
  font-size: 1.4rem;
}
.side-filter-wrapper .filter-wrapper .MuiList-root, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root {
  padding-top: 1.2rem;
}
.side-filter-wrapper .filter-wrapper .MuiList-root .MuiListItem-root, .side-filter-wrapper .filter-wrapper .MuiList-root .MuiFormControlLabel-root, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiListItem-root, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiFormControlLabel-root {
  padding: 0;
}
.side-filter-wrapper .filter-wrapper .MuiList-root .MuiListItem-root:hover, .side-filter-wrapper .filter-wrapper .MuiList-root .MuiFormControlLabel-root:hover, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiListItem-root:hover, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiFormControlLabel-root:hover {
  cursor: pointer;
}
.side-filter-wrapper .filter-wrapper .MuiList-root .MuiListItem-root .MuiButtonBase-root, .side-filter-wrapper .filter-wrapper .MuiList-root .MuiFormControlLabel-root .MuiButtonBase-root, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiListItem-root .MuiButtonBase-root, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiFormControlLabel-root .MuiButtonBase-root {
  padding: 0.4rem 0.6rem 0.4rem 0.4rem;
}
.side-filter-wrapper .filter-wrapper .MuiList-root .MuiListItem-root .MuiButtonBase-root svg, .side-filter-wrapper .filter-wrapper .MuiList-root .MuiFormControlLabel-root .MuiButtonBase-root svg, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiListItem-root .MuiButtonBase-root svg, .side-filter-wrapper .filter-wrapper .MuiFormGroup-root .MuiFormControlLabel-root .MuiButtonBase-root svg {
  width: 1rem;
  height: 1rem;
  color: rgba(0, 0, 0, 0.5);
}
.side-filter-wrapper .filter-wrapper .MuiSlider-root {
  padding-top: 3rem;
  width: 90%;
}

.custom-swipeable-drawer .box-wrapper {
  display: flex;
  justify-content: center;
}
.custom-swipeable-drawer .box-wrapper p {
  font-size: 1.5rem;
  color: rgba(0, 0, 0, 0.5);
}
.custom-swipeable-drawer .box-warpper-content p, .custom-swipeable-drawer .box-warpper-content ul, .custom-swipeable-drawer .box-warpper-content span {
  color: rgba(0, 0, 0, 0.5);
}

.footer-section {
  padding: 5rem;
  background: var(--mui-palette-secondary-main);
}
.footer-section span, .footer-section p, .footer-section button, .footer-section svg, .footer-section a {
  color: white;
}
.footer-section .logo {
  display: flex;
  padding: 0.2rem;
  align-items: center;
}
.footer-section .footer-content {
  padding: 2rem 0;
}
.footer-section .footer-content .description {
  font-size: 1rem;
  line-height: 1.5;
}

.dialog-title {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
}
.dialog-title .logo-wrapper img {
  height: 2.2rem;
}
.dialog-title .description {
  font-size: 0.8rem;
}

.dialog-body {
  padding: 2rem;
}
.dialog-body .form-wrapper {
  display: block;
}

.MuiDialogActions-root {
  padding: 0 2rem !important;
}
.MuiDialogActions-root button {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0 1.5rem 0;
}

.form-dialog-wrapper .dialog-action {
  padding: 1rem !important;
}
.form-dialog-wrapper .title-text {
  font-size: 1rem;
}
.form-dialog-wrapper .title-sec-text {
  font-size: 0.8rem;
}
.form-dialog-wrapper .form-wrapper {
  display: flex;
  flex-direction: column;
}
.form-dialog-wrapper .form-wrapper .form-label .label-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: black;
}
.form-dialog-wrapper .form-wrapper .form-label .label-sec-text {
  font-size: 0.8rem;
  color: black;
}
.form-dialog-wrapper .form-wrapper .form-control {
  display: flex;
  flex-direction: row;
}
.form-dialog-wrapper .form-wrapper .form-control .editor {
  width: 100%;
  height: 120px;
  margin-top: 0.5rem;
}
.form-dialog-wrapper .form-wrapper .form-control .editor .ql-toolbar {
  border-radius: 0.5rem 0.5rem 0 0;
}
.form-dialog-wrapper .form-wrapper .form-control .editor .ql-container {
  border-radius: 0 0 0.5rem 0.5rem;
}
.form-dialog-wrapper .form-wrapper .form-control .divider-text {
  padding: 0.5rem;
  display: flex;
  align-items: center;
}

.image-uploader-wrapper {
  width: 100%;
  margin-top: 0.5rem;
}
.image-uploader-wrapper .preview-container {
  display: flex;
  flex-direction: row;
}
.image-uploader-wrapper .uploader-wrapper {
  border: 1px dashed var(--mui-palette-primary-main);
  padding: 0.5rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.image-uploader-wrapper .uploader-wrapper svg {
  font-size: 3rem;
  margin-bottom: 0.4rem;
}
.image-uploader-wrapper .uploader-wrapper .uploader-text {
  font-size: 0.8rem;
  margin-bottom: 0.2rem;
}
.image-uploader-wrapper .uploader-wrapper .uploader-sec-text {
  font-size: 0.7rem;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper {
  width: 100%;
  min-height: 150px;
  display: flex;
  align-items: center;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .preview-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper {
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 1rem;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper {
  display: flex;
  flex-direction: column;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper .preview-text {
  font-size: 0.7rem;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper .preview-text .span-hidden {
  visibility: hidden;
  font-size: 0.7rem;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper .img-container {
  min-width: 120px;
  width: 100%;
  min-height: 100px;
  display: flex;
  justify-content: center;
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper .img-container img {
  position: relative;
  height: 80px;
  box-shadow: var(--mui-shadows-2);
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper .img-container .cancel-btn {
  z-index: 2;
  padding: 0;
  position: absolute;
  transform: translate(120%, -50%);
}
.image-uploader-wrapper .uploader-wrapper .image-list-wrapper .image-preview-wrapper .img-wrapper .img-container .cancel-btn svg {
  font-size: 1.2rem;
  margin-bottom: 0;
}
.image-uploader-wrapper .uploader-wrapper .input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.image-uploader-wrapper .uploader-wrapper .add-btn-wrapper {
  display: flex;
  justify-content: center;
  width: 40%;
}
.image-uploader-wrapper .uploader-wrapper .add-btn-wrapper svg {
  color: var(--mui-palette-secondary-main);
  font-size: 1.2rem;
  margin-bottom: 0;
}

.carousel-wrapper {
  width: 100%;
}
.carousel-wrapper .splide {
  width: 100%;
  margin: auto;
}
.carousel-wrapper .slider-card .content-card {
  box-shadow: var(--mui-shadows-4) !important;
}
.carousel-wrapper .slider-card .MuiCardMedia-root {
  background-position: center;
  background-size: contain;
}
.carousel-wrapper .slider-card .MuiCardActions-root {
  padding: 0 2rem 1rem 2rem !important;
}
@media (max-width: 800px) {
  .carousel-wrapper .splide {
    width: 85%;
  }
}

.bottom-nav-wrapper .bottom-nav-toolbar .fab-wrapper .img-wrapper {
  height: 100%;
}
.bottom-nav-wrapper .bottom-nav-toolbar .fab-wrapper .img-wrapper img {
  margin: 0 0 0 -0.35rem;
  height: 100%;
}
.bottom-nav-wrapper .bottom-nav-toolbar .toolbar-item {
  padding: 0.2rem;
}
.bottom-nav-wrapper .bottom-nav-toolbar .toolbar-item .MuiListItemButton-root {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bottom-nav-wrapper .bottom-nav-toolbar .toolbar-item .toolbar-icon {
  color: white;
  min-width: unset;
}
.bottom-nav-wrapper .bottom-nav-toolbar .toolbar-divider {
  border: 0.05rem solid;
  border-color: rgba(255, 255, 255, 0.5);
}

.drawer-list-wrapper {
  width: 360px !important;
}

.mobile-input-wrapper {
  display: flex;
}
.mobile-input-wrapper .select-input {
  width: 140px;
  padding: 8.5px 0px;
}
.dial-code-wrapper {
  display: flex;
  align-items: center;
}
.dial-code-wrapper img {
  height: 1rem;
  margin-right: 0.5rem;
}

.alert-wrapper {
  position: absolute;
  display: block;
  z-index: 3;
  right: 1.5rem; /*newly added*/
  top: 1rem;
}

.auth-layout-wrapper {
  padding: 65px 50px;
  min-height: 100vh;
  background-image: linear-gradient(to bottom right, white 50%, var(--mui-palette-primary-main));
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-layout-wrapper .auth-layout-container {
  height: -moz-fit-content;
  height: fit-content;
  min-height: 90vh;
}
.auth-layout-wrapper .logo-wrapper {
  display: flex;
  align-items: center;
}
.auth-layout-wrapper .logo-wrapper .img-wrapper {
  margin-right: 1rem;
}
.auth-layout-wrapper .logo-wrapper .img-wrapper img {
  height: 5rem;
}
.auth-layout-wrapper .content-wrapper {
  padding: 3rem 3rem 3rem 0;
}
.auth-layout-wrapper .content-wrapper .title {
  font-size: 2rem;
  font-weight: 600;
}
.auth-layout-wrapper .content-wrapper .description {
  font-size: 1rem;
}
.auth-layout-wrapper .svg-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: -5rem;
}
.auth-layout-wrapper .svg-wrapper svg {
  height: 25rem;
}
.auth-layout-wrapper .login-wrapper .card-wrapper {
  padding: 1.5rem 2rem;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.75);
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-label {
  font-weight: 600;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container {
  padding: 1rem 0 0 0;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper {
  padding-bottom: 0.4rem;
  width: 100%;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .button-wrapper {
  padding-top: 0.6rem;
  width: 100%;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .button-wrapper button {
  width: 100%;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .link-wrapper {
  padding-top: 0.6rem;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .link-wrapper span {
  font-size: 0.8rem;
  color: #688ad5;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .link-wrapper a {
  text-decoration: none;
}
.auth-layout-wrapper .login-wrapper .card-wrapper .form-container .select-wrapper .error-text {
  color: var(--mui-palette-error-main);
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 4px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
}
.auth-layout-wrapper .login-wrapper .sec-card-wrapper {
  padding: 1.5rem 2rem;
  background-color: rgba(0, 0, 0, 0.03);
}
.auth-layout-wrapper .login-wrapper .sec-card-wrapper .button-wrapper {
  padding: 0.5rem 0;
  width: 100%;
}
.auth-layout-wrapper .login-wrapper .sec-card-wrapper .button-wrapper a {
  border: 2px solid black;
  color: black;
  width: 100%;
  background-color: white;
}
.auth-layout-wrapper .login-wrapper .sec-card-wrapper .text-wrapper span {
  font-size: 0.7rem;
}
.auth-layout-wrapper .login-wrapper .sec-card-wrapper .text-wrapper a {
  color: #cd1479;
}

.condition-dialog-wrapper .MuiDialog-container .MuiDialog-paper {
  max-width: 900px;
}
.condition-dialog-wrapper .MuiDialog-container .MuiDialog-paper .policy-wrapper {
  line-height: 1.2;
}
.condition-dialog-wrapper .MuiDialog-container .MuiDialog-paper .dialog-action {
  padding: 0.5rem 1rem !important;
}
.condition-dialog-wrapper .MuiDialog-container .MuiDialog-paper .dialog-action button {
  width: -moz-fit-content;
  width: fit-content;
}

@media (max-width: 480px) {
  .auth-layout-wrapper {
    padding: 10px 50px;
  }
  .auth-layout-wrapper .content-wrapper {
    padding: 3rem 0 3rem 0;
  }
  .auth-layout-wrapper .svg-wrapper svg {
    width: 100%;
    height: unset;
  }
}
@media (min-width: 480px) and (max-width: 600px) {
  .auth-layout-wrapper {
    padding: 15px 80px;
  }
}
@media (min-width: 600px) and (max-width: 800px) {
  .auth-layout-wrapper {
    padding: 40px 50px;
  }
}
@media (min-width: 800px) and (max-width: 1200px) {
  .auth-layout-wrapper {
    padding: 40px 50px;
  }
  .signin__leftimg {
    width: 40%;
  }
  .signin__right {
    width: 60%;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .auth-layout-wrapper {
    padding: 65px 50px;
  }
  .signin__leftimg {
    width: 40%;
  }
  .signin__right {
    width: 60%;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) and (min-width: 1500px) and (max-width: 1900px) {
  .signin__right__top {
    width: 100%;
  }
  .signin__leftimg {
    width: 40%;
  }
  .signin__right {
    width: 60%;
  }
}
.sidenav-drawer .MuiToolbar-root .logo-wrapper {
  display: flex;
  align-items: center;
}
.sidenav-drawer .MuiToolbar-root .logo-wrapper .img-wrapper {
  height: 100%;
  margin-right: 1rem;
}
.sidenav-drawer .MuiToolbar-root .logo-wrapper .img-wrapper img {
  height: 3rem;
  margin-top: 0.5rem;
}
.sidenav-drawer .MuiDrawer-paper .list-wrapper {
  padding-top: 2rem;
}
.sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItem-root, .sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItemButton-root {
  padding-right: 2rem;
}
.sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItem-root svg, .sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItem-root span, .sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItemButton-root svg, .sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItemButton-root span {
  color: var(--mui-palette-custom-main);
  font-size: 0.9rem;
}
.sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItem-root .MuiListItemIcon-root, .sidenav-drawer .MuiDrawer-paper .list-wrapper .MuiListItemButton-root .MuiListItemIcon-root {
  min-width: 45px;
}
.dashboard-wrapper .right-content-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
  width: 100%;
}
.dashboard-wrapper .right-content-wrapper .content-wrapper {
  padding: 0rem 2rem;
}
.dashboard-wrapper .right-content-wrapper .action-item-nav-btn button {
  color: white;
}
.dashboard-wrapper .right-content-wrapper .action-item-nav-btn .nav-icon-btn {
  width: 8rem;
}
.dashboard-wrapper .right-content-wrapper .action-item-nav-btn .nav-icon-btn .nav-icon-svg {
  width: 1.5rem;
}
.dashboard-wrapper .right-content-wrapper .action-item-nav-btn .nav-icon-btn .nav-icon-svg:hover {
  font-size: 1.2rem;
}
@media (max-width: 1200px) {
  .dashboard-wrapper .empty-appbar {
    top: auto;
    bottom: 0;
    height: 6rem;
    position: relative;
    z-index: 0;
    box-shadow: unset;
  }
}

.setup-layout-wrapper {
  padding: 2rem 5rem;
  min-height: 100vh;
  background-image: linear-gradient(to bottom right, white 50%, var(--mui-palette-primary-main));
  display: flex;
}
.setup-layout-wrapper .setup-layout-container {
  height: -moz-fit-content;
  height: fit-content;
}
.setup-layout-wrapper .logo-wrapper {
  display: flex;
  align-items: center;
}
.setup-layout-wrapper .logo-wrapper .img-wrapper {
  margin-right: 1rem;
}
.setup-layout-wrapper .logo-wrapper .img-wrapper img {
  height: 2.5rem;
}
.setup-layout-wrapper .content-wrapper {
  padding: 3rem 3rem 3rem 0;
}
.setup-layout-wrapper .content-wrapper .title {
  font-size: 2.5rem;
  font-weight: 600;
}
.setup-layout-wrapper .content-wrapper .description {
  font-size: 1rem;
}
.setup-layout-wrapper .svg-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: -5rem;
}
.setup-layout-wrapper .svg-wrapper svg {
  height: 25rem;
}
.setup-layout-wrapper .login-wrapper .card-wrapper {
  padding: 1.5rem 2rem;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.75);
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-label {
  font-weight: 600;
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-container {
  padding: 1rem 0 0 0;
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper {
  padding-bottom: 0.4rem;
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .button-wrapper {
  padding-top: 0.6rem;
  width: 100%;
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .button-wrapper button {
  width: 100%;
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .link-wrapper {
  padding-top: 0.6rem;
}
.setup-layout-wrapper .login-wrapper .card-wrapper .form-container .form-wrapper .link-wrapper span {
  font-size: 0.8rem;
  color: var(--mui-palette-primary-main);
}
.setup-layout-wrapper .login-wrapper .sec-card-wrapper {
  padding: 1.5rem 2rem;
  background-color: rgba(0, 0, 0, 0.03);
}
.setup-layout-wrapper .login-wrapper .sec-card-wrapper .button-wrapper {
  padding: 0.5rem 0;
  width: 100%;
}
.setup-layout-wrapper .login-wrapper .sec-card-wrapper .button-wrapper a {
  border: 2px solid black;
  color: black;
  width: 100%;
  background-color: white;
}
.setup-layout-wrapper .login-wrapper .sec-card-wrapper .text-wrapper span {
  font-size: 0.7rem;
}

@media (max-width: 480px) {
  .setup-layout-wrapper {
    padding: 2rem 3rem;
  }
}
@media (min-width: 480px) and (max-width: 600px) {
  .setup-layout-wrapper {
    padding: 2rem 3rem;
  }
}
@media (min-width: 600px) and (max-width: 800px) {
  .setup-layout-wrapper {
    padding: 2rem 5rem;
  }
}
@media (min-width: 800px) and (max-width: 1200px) {
  .setup-layout-wrapper {
    padding: 2rem 3rem;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .setup-layout-wrapper {
    padding: 2rem 4rem;
  }
}
.website-analytics-wrapper .component-grid .dashboard-card-wrapper .content-bottom-wrapper {
  padding: 0 1rem 2rem 1rem !important;
}
.website-analytics-wrapper .component-grid .list-wrapper .header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.website-analytics-wrapper .dashboard-table-container {
  padding: 1rem 0 !important;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root {
  box-shadow: none;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableHead-root span {
  font-size: 0.7rem;
  font-weight: 600;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root span {
  font-size: 0.7rem;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .row-flex {
  display: flex;
  align-items: center;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .row-flex .cell-text {
  margin-right: 3rem;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label {
  display: flex;
  align-items: center;
  background-color: var(--mui-palette-success-light);
  border-radius: 1rem;
  padding: 0.3rem;
  width: -moz-fit-content;
  width: fit-content;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label svg {
  font-size: 1rem;
  margin-right: 0.3rem;
  color: white;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label span {
  margin-right: 0.3rem;
  color: white;
}
.website-analytics-wrapper .dashboard-table-container .rating-wrapper .MuiRating-root {
  font-size: 1rem !important;
}
.website-analytics-wrapper .dashboard-table-container .rating-wrapper .MuiRating-root .MuiRating-icon {
  font-size: 1rem !important;
}

.form-grid-container {
  width: 100%;
}
.form-grid-container .form-wrapper {
  width: 100%;
  padding: 0 0 1rem 0;
}
.form-grid-container .multi-form-ele {
  width: 100%;
}
.form-grid-container .multi-form-ele .form-control {
  width: 100%;
  padding: 0.3rem 0;
}
.form-grid-container .multi-form-ele .form-control .adornment-icon {
  margin-right: 0.5rem;
}

@media (min-width: 360px) and (max-width: 900px) {
  .overlay-wrapper .subscription-card {
    padding-top: 40%;
    justify-content: flex-start !important;
  }
}
.layout-view {
  width: 100%;
  font-size: 2rem;
  left: 0;
  top: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-view .main-view {
  flex: 1 1;
}
.layout-view .banner-section {
  width: 100%;
}
.layout-view .banner-section .banner-content {
  background-size: cover;
  background-repeat: no-repeat;
}
.layout-view .banner-section .gradient-content {
  background-color: #29aecc; /* For browsers that do not support gradients */
  background-image: linear-gradient(to bottom left, #29aecc, white);
}
.layout-view .banner-section .title-section {
  padding: 5rem 4rem;
  height: 100%;
}
.layout-view .banner-section .title-section .title {
  font-size: 2.4rem;
}
.layout-view .banner-section .title-section .description {
  font-size: 1.2rem;
  line-height: 1.5;
}
.layout-view .draft-section {
  padding: 3rem;
}
.layout-view .draft-section .title-section {
  width: 70%;
}
.layout-view .draft-section .title-section .description {
  font-size: 1rem;
  line-height: 1.5rem;
}
.layout-view .draft-section .content-section {
  display: flex;
  flex-direction: row;
  padding: 1rem 0;
}
.layout-view .draft-section .content-section .content-card {
  margin-right: 1rem;
  width: 25%;
}
.layout-view .draft-section .content-section .content-card .MuiCardContent-root {
  padding: 0;
}
.layout-view .draft-section .content-section .content-card .MuiCardActions-root {
  padding: 0 0 0.7rem 0;
  display: block;
}

.landing-wrapper .view-wrapper {
  padding: 1rem 3rem;
}
.landing-wrapper .view-wrapper .detail-wrapper {
  padding: 4rem 4rem;
  display: flex;
  flex-direction: column;
}
.landing-wrapper .view-wrapper .detail-wrapper .title {
  font-size: 4rem;
  font-weight: 900;
}
.landing-wrapper .view-wrapper .detail-wrapper .sec-title {
  font-size: 1rem;
}
.landing-wrapper .view-wrapper .detail-wrapper button {
  width: 300px;
}
@media (max-width: 800px) {
  .landing-wrapper .view-wrapper .detail-wrapper {
    padding: 2rem 2rem;
  }
  .landing-wrapper .view-wrapper .detail-wrapper .title {
    font-size: 3rem;
  }
}
@media (min-width: 800px) and (max-width: 1200px) {
  .landing-wrapper .view-wrapper .detail-wrapper {
    padding: 4rem 3rem;
  }
  .landing-wrapper .view-wrapper .detail-wrapper .title {
    font-size: 3rem;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .landing-wrapper .view-wrapper .detail-wrapper {
    padding: 4rem 3rem;
  }
  .landing-wrapper .view-wrapper .detail-wrapper .title {
    font-size: 3rem;
  }
}
@media (max-width: 800px) {
  .landing-wrapper .view-wrapper {
    padding: 1rem 1rem;
  }
}

.home-wrapper .dashboard-card-wrapper .content-wrapper {
  padding: 0 0 1rem 0 !important;
}
.home-wrapper .dashboard-card-wrapper .justified-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 0;
}
.home-wrapper .dashboard-card-wrapper .MuiCardContent-root {
  padding: 0 1rem;
}
.home-wrapper .dashboard-card-wrapper .justified-center-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 1rem 0;
}
.home-wrapper .secondary-card {
  margin-top: 1rem;
}
.home-wrapper .setup-card {
  padding: 1rem;
}
.home-wrapper .setup-card .step-form-container {
  padding: 2rem;
}
.home-wrapper .setup-card .stepper-wrapper {
  padding: 0;
}
.home-wrapper .setup-card .stepper-wrapper .divider {
  margin: 0.5rem 0;
}
.home-wrapper .setup-card .stepper-wrapper .checklist-wrapper .icon-btn-directional svg {
  font-size: 1rem;
}
.home-wrapper .setup-card .action-grid {
  padding: 1rem;
  display: flex;
  align-items: center;
}
.home-wrapper .setup-card .action-grid .logo-image {
  height: 36px;
  margin-right: 22px;
}

.overlay-wrapper {
  position: relative;
}
.overlay-wrapper .overlay-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  color: black;
  background-color: rgba(255, 255, 255, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.overlay-wrapper .overlay-card .statement {
  font-size: 1.2rem;
}
.overlay-wrapper .overlay-card .statement-svg {
  height: 7rem;
}
.overlay-wrapper .subscription-card {
  width: 400px;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 899;
  color: black;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: flex-start;
  padding-top: 10%;
  align-items: center;
  flex-direction: column;
}
.overlay-wrapper .subscription-card .statement {
  font-size: 1.5rem;
}
.overlay-wrapper .subscription-card .statement-svg {
  height: 10rem;
}

.subscription-overlay {
  min-height: 100vh;
}

.nan-wrapper {
  padding: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--mui-palette-custom-main);
}
.nan-wrapper svg {
  height: 20rem;
}

.website-analytics-wrapper .component-grid .dashboard-card-wrapper .content-wrapper {
  padding: 1rem 0 !important;
}
.website-analytics-wrapper .component-grid .dashboard-card-wrapper .content-bottom-wrapper {
  padding: 0 1rem 2.5rem 1rem !important;
}
.website-analytics-wrapper .component-grid .list-wrapper .header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.website-analytics-wrapper .component-grid .list-wrapper .header-wrapper_category {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.website-analytics-wrapper .dashboard-table-container {
  padding: 1rem 0 !important;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root {
  box-shadow: none;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableHead-root span {
  font-size: 0.7rem;
  font-weight: 600;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root span {
  font-size: 0.7rem;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .row-flex {
  display: flex;
  align-items: center;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .row-flex .cell-text {
  margin-right: 3rem;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label {
  display: flex;
  align-items: center;
  background-color: var(--mui-palette-success-light);
  border-radius: 1rem;
  padding: 0.3rem;
  width: -moz-fit-content;
  width: fit-content;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label svg {
  font-size: 1rem;
  margin-right: 0.3rem;
  color: white;
}
.website-analytics-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label span {
  margin-right: 0.3rem;
  color: white;
}
.website-analytics-wrapper .dashboard-table-container .rating-wrapper .MuiRating-root {
  font-size: 1rem !important;
}
.website-analytics-wrapper .dashboard-table-container .rating-wrapper .MuiRating-root .MuiRating-icon {
  font-size: 1rem !important;
}

.form-grid-container {
  width: 100%;
}
.form-grid-container .form-wrapper {
  width: 100%;
  padding: 0 0 1rem 0;
}
.form-grid-container .multi-form-ele {
  width: 100%;
}
.form-grid-container .multi-form-ele .form-control {
  width: 100%;
  padding: 0.3rem 0;
}
.form-grid-container .multi-form-ele .form-control .adornment-icon {
  margin-right: 0.5rem;
}

.store-analytics-wrapper .MuiCardContent-root {
  padding: 0 1rem 1.5rem 1rem;
}

.breadcrumb-wrapper {
  padding: 0.5rem 0 1rem 0;
}
.breadcrumb-wrapper li,
.breadcrumb-wrapper p {
  font-size: 1.2rem;
  font-weight: 600;
  color: "black";
}

.component-grid {
  padding: 0.5rem 0;
}

.dashboard-card-wrapper {
  box-shadow: var(--mui-shadows-4) !important;
}
.dashboard-card-wrapper .header-wrapper {
  padding: 1rem 0;
}
.dashboard-card-wrapper .header-wrapper .header-text {
  font-size: 1rem;
  font-weight: 600;
}
.dashboard-card-wrapper .header-wrapper .header-sec-text {
  font-size: 0.7rem;
}
.dashboard-card-wrapper .dashboard-table-container {
  padding: 1rem 0 !important;
}
.dashboard-card-wrapper .dashboard-table-container .MuiGrid-item {
  max-width: 100%;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root {
  box-shadow: none;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableHead-root span {
  font-size: 0.7rem;
  font-weight: 600;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root span {
  font-size: 0.7rem;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .row-flex {
  display: flex;
  align-items: center;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .row-flex .cell-text {
  margin-right: 3rem;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label {
  display: flex;
  align-items: center;
  background-color: var(--mui-palette-success-light);
  border-radius: 1rem;
  padding: 0.3rem;
  width: -moz-fit-content;
  width: fit-content;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label svg {
  font-size: 1rem;
  margin-right: 0.3rem;
  color: white;
}
.dashboard-card-wrapper .dashboard-table-container .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .cell-label span {
  margin-right: 0.3rem;
  color: white;
}
.dashboard-card-wrapper .content-wrapper {
  padding: 1rem 0 1rem 0 !important;
}
.dashboard-card-wrapper .content-wrapper .content-text {
  font-size: 0.7rem;
}
.dashboard-card-wrapper .content-wrapper .figure-text {
  font-size: 2rem;
  font-weight: 800;
}
.dashboard-card-wrapper .content-wrapper svg {
  height: 10rem;
}
.dashboard-card-wrapper .content-wrapper .detail-action-wrapper {
  width: 40%;
}
.dashboard-card-wrapper .content-wrapper .detail-action-wrapper .detail-text {
  font-size: 1.4rem;
}
.dashboard-card-wrapper .content-wrapper .detail-action-wrapper .detail-sec-text {
  font-size: 1rem;
}
.dashboard-card-wrapper .content-wrapper .detail-action-wrapper .button-wrapper svg {
  height: 1rem;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper {
  width: 100%;
  align-items: center;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .select-wrapper {
  padding: 0 0.5rem;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .select-wrapper svg {
  height: unset;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card {
  width: 100%;
  padding: 1rem 1.5rem;
  border-radius: 0.5rem;
  background-color: rgba(100, 100, 100, 0.1);
  margin-bottom: 1rem;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .label-text {
  font-size: 0.7rem;
  color: var(--mui-palette-success-light);
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .payment-header {
  display: flex;
  justify-content: space-between;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .payment-header .detail-sec-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .payment-header .detail-sec-wrapper .logo-image {
  height: 2rem;
  margin-right: 1rem;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .payment-detail {
  padding: 0.5rem 0;
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .payment-detail span {
  font-size: 0.85rem;
}
@media only screen and (max-width: 500px) {
  .dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .payment-detail .MuiButtonBase-root {
    margin-bottom: 1rem;
  }
}
.dashboard-card-wrapper .content-wrapper .filter-wrapper .payment-card .divider {
  margin: 1rem 0 !important;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .plan-card-wrapper {
  padding: 1rem 1rem;
  box-shadow: var(--mui-shadows-1);
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .plan-card-wrapper .detail-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 400px;
  width: 100%;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .plan-card-wrapper .detail-wrapper .plan-text {
  min-height: 7vh;
  font-size: 1rem;
  text-transform: uppercase;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .plan-card-wrapper .detail-wrapper .plan-sec-text {
  font-size: 0.7rem;
  min-height: 10vh;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .plan-card-wrapper .detail-wrapper .separator {
  width: 3rem;
  border: 1px solid;
  margin: 0.3rem;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .plan-card-wrapper .detail-wrapper img {
  height: 8rem;
  margin: 1rem;
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .selected {
  box-shadow: var(--mui-shadows-6);
}
.dashboard-card-wrapper .content-wrapper .plan-wrapper .selected button {
  box-shadow: var(--mui-shadows-2);
}
.dashboard-card-wrapper .content-wrapper .status-wrapper {
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .dashboard-card-wrapper .filter-bar-wrapper {
    flex-direction: column;
  }
  .dashboard-card-wrapper .filter-bar-wrapper .search-bar {
    margin-left: 0;
    margin-top: 1rem;
  }
  .dashboard-card-wrapper .filter-bar-wrapper .search-bar .search-input {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .dashboard-card-wrapper .search-bar {
    margin-left: 0;
    margin-top: 1rem;
    margin-right: 0;
  }
  .dashboard-card-wrapper .search-bar .search-input {
    width: 100%;
  }
}
.dashboard-card-wrapper .content-flex {
  display: flex;
}
.dashboard-card-wrapper .content-flex-right {
  justify-content: end;
}
.dashboard-card-wrapper .content-flex-center {
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.dashboard-card-wrapper .date-wrapper .MuiStack-root {
  width: 100%;
}
.dashboard-card-wrapper .date-wrapper .MuiStack-root .MuiTextField-root .MuiInputBase-root input {
  padding: 8.5px 14px;
}
.dashboard-card-wrapper .dashboard-details-container {
  padding: 2rem 3rem;
}
.dashboard-card-wrapper .dashboard-details-container .image-grid .image-container {
  height: 300px;
}
.dashboard-card-wrapper .dashboard-details-container .image-grid .image-container img {
  height: 100%;
}
.dashboard-card-wrapper .dashboard-details-container .order-detail-container {
  line-height: 2;
  padding: 2rem 5rem;
}
.dashboard-card-wrapper .dashboard-details-container .order-detail-container .payment-mode-wrapper {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  width: 50%;
  padding: 0.5rem 1rem;
  margin: 0.2rem 0 0.5rem 0;
  display: flex;
  justify-content: space-between;
}
.dashboard-card-wrapper .dashboard-details-container .order-detail-container .action-wrapper {
  padding-top: 2rem;
}
.dashboard-card-wrapper .dashboard-details-container .order-detail-container .action-wrapper button {
  width: 100%;
}
.dashboard-card-wrapper .dashboard-details-container .order-detail-container .content-divider {
  margin: 1rem 0;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-label .label-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: black;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-label .label-text .required {
  color: red;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-label .label-sec-text {
  font-size: 0.7rem;
  color: black;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control .editor {
  width: 100%;
  height: 120px;
  margin-top: 0.5rem;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control .editor .ql-toolbar {
  border-radius: 0.5rem 0.5rem 0 0;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control .editor .ql-container {
  border-radius: 0 0 0.5rem 0.5rem;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control .error-text {
  color: var(--mui-palette-error-main);
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 4px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control .divider-text {
  padding: 0.5rem;
  display: flex;
  align-items: center;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .form-control .quill-wrapper {
  width: 100%;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .select-wrapper {
  margin-top: 0.5rem;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .select-wrapper .error-text {
  color: var(--mui-palette-error-main);
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 4px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .select-wrapper .whatsapp_switch_container {
  display: flex;
  justify-content: space-between;
}
.dashboard-card-wrapper .dashboard-form-container .form-wrapper .select-wrapper .label-sec-text {
  font-size: 0.7rem;
}
.dashboard-card-wrapper .dashboard-form-container .multiple-ele {
  padding-top: 1rem;
}
.dashboard-card-wrapper .dashboard-form-container .toggle-ele {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.dashboard-card-wrapper .footer-wrapper {
  background-color: var(--mui-palette-custom-main);
}
.dashboard-card-wrapper .footer-wrapper .action-wrapper {
  padding: 1rem 0;
  display: flex;
  justify-content: end;
}
.dashboard-card-wrapper .footer-wrapper .action-wrapper button {
  margin-left: 1rem;
}

.address-wrapper {
  width: 90%;
  padding: 0.3rem 0;
  line-height: 1.5;
}
.address-wrapper .content-divider {
  margin: 0.5rem 0;
}

.credential-dialog .MuiDialog-paper {
  width: 600px;
}
.credential-dialog .MuiDialog-paper .credential-wrapper {
  width: 100%;
}
.credential-dialog .MuiDialog-paper .credential-wrapper .form-wrapper .form-control {
  margin-bottom: 0.4rem;
}
.credential-dialog .MuiDialog-paper .credential-wrapper .form-wrapper .required {
  color: red;
}

.setup-wrapper {
  margin-top: 1rem;
}
.setup-wrapper .component-grid .list-wrapper .form-grid-container {
  width: 100%;
}
.setup-wrapper .component-grid .list-wrapper .form-grid-container .MuiGrid-root {
  width: 100%;
}

.stepper-wrapper {
  padding: 3rem 1.5rem;
}
.stepper-wrapper .title {
  font-size: 1rem;
  font-weight: 600;
}
.stepper-wrapper .description {
  font-size: 0.8rem;
}

@media (max-width: 480px) {
  .stepper-wrapper {
    width: 100%;
    padding: 3rem 1.5rem;
  }
}
@media (min-width: 480px) and (max-width: 600px) {
  .stepper-wrapper {
    width: 100%;
    padding: 3rem 1.5rem;
  }
}
@media (min-width: 600px) and (max-width: 800px) {
  .stepper-wrapper {
    width: 100%;
    padding: 3rem 0 3rem 1.5rem;
  }
}
@media (min-width: 800px) and (max-width: 1200px) {
  .stepper-wrapper {
    width: 100%;
    padding: 3rem 0 3rem 1.5rem;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .stepper-wrapper {
    padding: 3rem 0 3rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/scss/common.scss","webpack://./src/styles/app.global.scss","webpack://./src/styles/scss/colors.scss","webpack://./src/styles/scss/font.scss","webpack://./src/containers/AppBar/AppBar.scss","webpack://./src/containers/SecondaryAppBar/SecondaryAppBar.scss","webpack://./src/containers/DynamicFilter/DynamicFilter.scss","webpack://./src/containers/Footer/Footer.scss","webpack://./src/components/Dialog/dialog.scss","webpack://./src/components/Inputs/ImageUploader/ImageUploader.scss","webpack://./src/components/Carousel/Carousel.scss","webpack://./src/components/Navigation/Navigation.scss","webpack://./src/components/components.scss","webpack://./src/containers/Layouts/AuthLayout/Auth.scss","webpack://./src/containers/SideNavigation/SideNavigation.scss","webpack://./src/containers/Layouts/DashboardLayout/Dashboard.scss","webpack://./src/containers/Layouts/SetupLayout/SetupLayout.scss","webpack://./src/views/Landing/Pricing.scss","webpack://./src/views/Landing/landing.scss","webpack://./src/views/Dashboard/Home/Home.scss","webpack://./src/views/Dashboard/NaN/NaN.scss","webpack://./src/views/Dashboard/Website/Website.scss","webpack://./src/views/Dashboard/Store/Store.scss","webpack://./src/views/InitialSetup/InitialSetup.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;ACIJ;;ADGA;EACI,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;ACAJ;;ADGA;EACI,4DAAA;ACAJ;ADEI;EACI,YAAA;ACAR;;ADIA;EACI,yBAAA;ACDJ;;ADIA;EACI,kBAAA;ACDJ;ADEI;EACI,gBAAA;ACAR;ADGI;EACI,eAAA;ACDR;;AAzBA;EACE,kBAAA;AA4BF;AAhBE;EACE,gBCGW;ADef;AAfE;EEUE,4CAAA;EACA,gBAAA;AFQJ;AAdE;EACE,eAAA;AAgBJ;AALE;EACE,2BAAA;AAOJ;AAJE;;EAEE,wBAAA;AAMJ;AAHE;EACE,0BAAA;AAKJ;;AADA;EACE;IACE,mBAAA;EAIF;AACF;AADA;EACE;IACE,mBAAA;EAGF;AACF;AAAA;EACE;IACE,mBAAA;EAEF;AACF;AACA;EACE;IACE,mBAAA;EACF;AACF;AG7EI;EACI,YAAA;AH+ER;AG5EQ;EACI,iBAAA;AH8EZ;AG7EY;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AH+EhB;AG3EI;EACI,YAAA;EACA,kBAAA;AH6ER;AG5EQ;EAEI,YAAA;EACA,kBAAA;AH6EZ;AGzEI;EACI,YAAA;AH2ER;;AGvEA;EACI,oBAAA;AH0EJ;AGzEI;EACI,mBAAA;AH2ER;AGxEI;EACI,YAAA;EACA,kBAAA;AH0ER;AGzEQ;EACI,cAAA;AH2EZ;AGvEI;EACI,qBAAA;EACA,mBAAA;AHyER;AGvEQ;EACI,WAAA;AHyEZ;AGxEY;EACI,WAAA;AH0EhB;AGtEI;EACI;IACI,sBAAA;EHwEV;AACF;AGtEI;EACI,iBAAA;AHwER;;AGnEI;EACI,kCAAA;AHsER;AGrEQ;EACI,aAAA;EACA,uBAAA;AHuEZ;AGpEI;EACI,YAAA;AHsER;;AGlEA;EACI;IACI,2BAAA;EHqEN;AACF;AGlEA;EACI;IACI,oBAAA;EHoEN;AACF;AI5JA;EACI,mDHSa;EGRb,+BAAA;EACA,YAAA;EACA,aAAA;AJ8JJ;AI5JI;EAGI,oBAAA;AJ4JR;AIzJI;EACI,YAAA;AJ2JR;AIvJQ;EACI,kBAAA;AJyJZ;;AIpJA;EACI;IAEI,qBAAA;IACA,cAAA;EJsJN;AACF;AIlJI;EACI,uBAAA;AJoJR;;AKlLI;EAEI,UAAA;ALoLR;AKnLQ;EACI,iBAAA;ALqLZ;AKnLQ;EACI,mBAAA;ALqLZ;AKpLY;EACI,UAAA;ALsLhB;AKrLgB;EACI,eAAA;ALuLpB;AKrLgB;EACI,oCAAA;ALuLpB;AKtLoB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;ALwLxB;AKnLQ;EACI,iBAAA;EACA,UAAA;ALqLZ;;AK/KI;EAEI,aAAA;EACA,uBAAA;ALiLR;AKhLQ;EACI,iBAAA;EACA,yBAAA;ALkLZ;AK9KQ;EACI,yBAAA;ALgLZ;;AM7NA;EACI,aAAA;EACA,6CLQa;ADwNjB;AM9NI;EACI,YAAA;ANgOR;AM7NI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;AN+NR;AM5NI;EACI,eAAA;AN8NR;AM7NQ;EACI,eAAA;EACA,gBAAA;AN+NZ;;AOjPA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;APoPJ;AOjPQ;EACI,cAAA;APmPZ;AO/OI;EACI,iBAAA;APiPR;;AO7OA;EACI,aAAA;APgPJ;AO9OI;EACI,cAAA;APgPR;;AO5OA;EACI,0BAAA;AP+OJ;AO7OI;EACI,WAAA;AP+OR;;AO3OA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,wBAAA;AP8OJ;;AO1OI;EACI,wBAAA;AP6OR;AO3OI;EACI,eAAA;AP6OR;AO3OI;EACI,iBAAA;AP6OR;AO3OI;EACI,aAAA;EACA,sBAAA;AP6OR;AO3OY;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;AP6OhB;AO3OY;EACI,iBAAA;EACA,YAAA;AP6OhB;AO1OQ;EAcI,aAAA;EACA,mBAAA;AP+NZ;AO5OY;EACI,WAAA;EACA,aAAA;EACA,kBAAA;AP8OhB;AO5OgB;EACI,gCAAA;AP8OpB;AO5OgB;EACI,gCAAA;AP8OpB;AOzOY;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AP2OhB;;AQ9TA;EACI,WAAA;EACA,kBAAA;ARiUJ;AQhUI;EACI,aAAA;EACA,mBAAA;ARkUR;AQhUI;EACI,kDAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ARkUR;AQjUQ;EACI,eAAA;EACA,qBAAA;ARmUZ;AQjUQ;EACI,iBAAA;EACA,qBAAA;ARmUZ;AQjUQ;EACI,iBAAA;ARmUZ;AQjUQ;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;ARmUZ;AQ5TY;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AR8ThB;AQ5TY;EAEI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;AR6ThB;AQ5TgB;EACI,aAAA;EACA,sBAAA;AR8TpB;AQ7ToB;EACI,iBAAA;AR+TxB;AQ9TwB;EACI,kBAAA;EACA,iBAAA;ARgU5B;AQ7ToB;EAEI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AR8TxB;AQ7TwB;EACI,kBAAA;EACA,YAAA;EACA,gCAAA;AR+T5B;AQ7TwB;EACI,UAAA;EACA,UAAA;EAIA,kBAAA;EAQA,gCAAA;ARqT5B;AQ5T4B;EACI,iBAAA;EACA,gBAAA;AR8ThC;AQnTQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;ARqTZ;AQnTQ;EACI,aAAA;EACA,uBAAA;EACA,UAAA;ARqTZ;AQpTY;EACI,wCP9FC;EO+FD,iBAAA;EACA,gBAAA;ARsThB;;AShaA;EACI,WAAA;ATmaJ;ASjaI;EACI,WAAA;EACA,YAAA;ATmaR;ASzZQ;EACI,2CAAA;AT2ZZ;ASxZQ;EAEI,2BAAA;EACA,wBAAA;ATyZZ;ASlZQ;EACI,oCAAA;AToZZ;AShZI;EACI;IACI,UAAA;ETkZV;AACF;;AUpbY;EACI,YAAA;AVubhB;AUtbgB;EACI,sBAAA;EACA,YAAA;AVwbpB;AUpbQ;EACI,eAAA;AVsbZ;AUrbY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AVubhB;AUrbY;EACI,YAAA;EACA,gBAAA;AVubhB;AUjbQ;EACI,qBAAA;EACA,sCAAA;AVmbZ;;AU9aA;EACI,uBAAA;AVibJ;;AW9cA;EAEI,aAAA;AXgdJ;AW5cI;EACI,YAAA;EACA,kBAAA;AX8cR;AWrcA;EACI,aAAA;EACA,mBAAA;AXucJ;AWtcI;EACI,YAAA;EACA,oBAAA;AXwcR;;AWrcA;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA,EAAA,cAAA;EACA,SAAA;AXwcJ;;AY3eA;EACE,kBAAA;EACA,iBAAA;EAKA,8FAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AZ0eF;AYxeE;EACE,wBAAA;EAAA,mBAAA;EACA,gBAAA;AZ0eJ;AYveE;EACE,aAAA;EACA,mBAAA;AZyeJ;AYxeI;EACE,kBAAA;AZ0eN;AYzeM;EACE,YAAA;AZ2eR;AYteE;EACE,yBAAA;AZweJ;AYveI;EACE,eAAA;EACA,gBAAA;AZyeN;AYveI;EACE,eAAA;AZyeN;AYreE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;AZueJ;AYteI;EACE,aAAA;AZweN;AYleI;EACE,oBAAA;EAEA,gDAAA;AZmeN;AYleM;EACE,gBAAA;AZoeR;AYleM;EACE,mBAAA;AZoeR;AYneQ;EACE,sBAAA;EACA,WAAA;AZqeV;AYpeU;EACE,mBAAA;EACA,WAAA;AZseZ;AYreY;EACE,WAAA;AZued;AYpeU;EACE,mBAAA;AZseZ;AYreY;EACE,iBAAA;EACA,cAAA;AZued;AYreY;EACE,qBAAA;AZued;AYleU;EACE,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AZoeZ;AY/dI;EACE,oBAAA;EACA,qCAAA;AZieN;AYheM;EACE,iBAAA;EACA,WAAA;AZkeR;AYjeQ;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AZmeV;AY/dQ;EACE,iBAAA;AZieV;AY/dQ;EACE,cAAA;AZieV;;AYxdI;EACE,gBAAA;AZ2dN;AY1dM;EACE,gBAAA;AZ4dR;AY1dM;EACE,+BAAA;AZ4dR;AY3dQ;EACE,uBAAA;EAAA,kBAAA;AZ6dV;;AYtdA;EACE;IACE,kBAAA;EZydF;EYxdE;IACE,sBAAA;EZ0dJ;EYvdI;IACE,WAAA;IACA,aAAA;EZydN;AACF;AYpdA;EACE;IACE,kBAAA;EZsdF;AACF;AYndA;EACE;IACE,kBAAA;EZqdF;AACF;AYndA;EACE;IACE,kBAAA;EZqdF;EYndA;IACE,UAAA;EZqdF;EYndA;IACE,UAAA;EZqdF;AACF;AYndA;EACE;IACE,kBAAA;EZqdF;EYndA;IACE,UAAA;EZqdF;EYndA;IACE,UAAA;EZqdF;AACF;AYpdE;EACE;IACE,WAAA;EZsdJ;EYpdE;IACE,UAAA;EZsdJ;EYpdE;IACE,UAAA;EZsdJ;AACF;AavpBQ;EACI,aAAA;EACA,mBAAA;AbypBZ;AaxpBY;EACI,YAAA;EACA,kBAAA;Ab0pBhB;AazpBgB;EAEI,YAAA;EACA,kBAAA;Ab0pBpB;AappBQ;EACI,iBAAA;AbspBZ;AarpBY;EACI,mBAAA;AbupBhB;AatpBgB;EACI,qCAAA;EACA,iBAAA;AbwpBpB;AatpBgB;EACI,eAAA;AbwpBpB;ActoBI;EACI,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,iBAAA;EACA,WAAA;AdwoBR;AcvoBQ;EACI,kBAAA;AdyoBZ;ActoBY;EACI,YAAA;AdwoBhB;ActoBY;EACI,WAAA;AdwoBhB;AcvoBgB;EACI,aAAA;AdyoBpB;AcxoBoB;EACI,iBAAA;Ad0oBxB;AcnoBI;EACI;IACI,SAAA;IACA,SAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;IACA,iBAAA;EdqoBV;AACF;;AeltBA;EACI,kBAAA;EACA,iBAAA;EACA,8FAAA;EACA,aAAA;AfqtBJ;AeltBI;EACI,wBAAA;EAAA,mBAAA;AfotBR;AejtBI;EACI,aAAA;EACA,mBAAA;AfmtBR;AeltBQ;EACI,kBAAA;AfotBZ;AentBY;EACI,cAAA;AfqtBhB;AehtBI;EACI,yBAAA;AfktBR;AejtBQ;EACI,iBAAA;EACA,gBAAA;AfmtBZ;AejtBQ;EACI,eAAA;AfmtBZ;Ae/sBI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;AfitBR;AehtBQ;EACI,aAAA;AfktBZ;Ae5sBQ;EACI,oBAAA;EAEA,gDAAA;Af6sBZ;Ae5sBY;EACI,gBAAA;Af8sBhB;Ae5sBY;EACI,mBAAA;Af8sBhB;Ae7sBgB;EACI,sBAAA;Af+sBpB;Ae9sBoB;EACI,mBAAA;EACA,WAAA;AfgtBxB;Ae/sBwB;EACI,WAAA;AfitB5B;Ae9sBoB;EACI,mBAAA;AfgtBxB;Ae/sBwB;EACI,iBAAA;EACA,sCd5Db;AD6wBf;Ae3sBQ;EACI,oBAAA;EACA,qCAAA;Af6sBZ;Ae5sBY;EACI,iBAAA;EACA,WAAA;Af8sBhB;Ae7sBgB;EACI,uBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;Af+sBpB;Ae3sBgB;EACI,iBAAA;Af6sBpB;;AetsBA;EACI;IACI,kBAAA;EfysBN;AACF;AetsBA;EACI;IACI,kBAAA;EfwsBN;AACF;AersBA;EACI;IACI,kBAAA;EfusBN;AACF;AersBA;EACI;IACI,kBAAA;EfusBN;AACF;AersBA;EACI;IACI,kBAAA;EfusBN;AACF;AgBzzBM;EACE,oCAAA;AhB2zBR;AgBvzBM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AhByzBR;AgBrzBE;EACE,0BAAA;AhBuzBJ;AgBrzBI;EACE,gBAAA;AhBuzBN;AgBpzBU;EACE,iBAAA;EACA,gBAAA;AhBszBZ;AgBlzBU;EACE,iBAAA;AhBozBZ;AgBlzBU;EACE,aAAA;EACA,mBAAA;AhBozBZ;AgBnzBY;EACE,kBAAA;AhBqzBd;AgBlzBU;EACE,aAAA;EACA,mBAAA;EACA,kDfvBI;EewBJ,mBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;AhBozBZ;AgBlzBY;EACE,eAAA;EACA,oBAAA;EACA,YAAA;AhBozBd;AgBlzBY;EACE,oBAAA;EACA,YAAA;AhBozBd;AgB7yBM;EACE,0BAAA;AhB+yBR;AgB9yBQ;EACE,0BAAA;AhBgzBV;;AgBzyBA;EACE,WAAA;AhB4yBF;AgB3yBE;EACE,WAAA;EACA,mBAAA;AhB6yBJ;AgB3yBE;EACE,WAAA;AhB6yBJ;AgB5yBI;EACE,WAAA;EACA,iBAAA;AhB8yBN;AgB7yBM;EACE,oBAAA;AhB+yBR;;AgBzyBA;EACE;IACE,gBAAA;IACA,sCAAA;EhB4yBF;AACF;AiB14BA;EACE,WAAA;EACA,eAAA;EAEA,OAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AjB24BF;AiBz4BE;EACE,SAAA;AjB24BJ;AiBx4BE;EACE,WAAA;AjB04BJ;AiBx4BI;EACE,sBAAA;EACA,4BAAA;AjB04BN;AiBx4BI;EACE,yBAAA,EAAA,+CAAA;EACA,iEAAA;AjB04BN;AiBx4BI;EACE,kBAAA;EACA,YAAA;AjB04BN;AiBz4BM;EACE,iBAAA;AjB24BR;AiBz4BM;EACE,iBAAA;EACA,gBAAA;AjB24BR;AiBh4BE;EACE,aAAA;AjBk4BJ;AiBh4BI;EACE,UAAA;AjBk4BN;AiBj4BM;EACE,eAAA;EACA,mBAAA;AjBm4BR;AiBh4BI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AjBk4BN;AiBh4BM;EACE,kBAAA;EACA,UAAA;AjBk4BR;AiBh4BQ;EACE,UAAA;AjBk4BV;AiB/3BQ;EACE,qBAAA;EACA,cAAA;AjBi4BV;;AiBz3BE;EACE,kBAAA;AjB43BJ;AiB33BI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AjB63BN;AiB53BM;EACE,eAAA;EACA,gBAAA;AjB83BR;AiB53BM;EACE,eAAA;AjB83BR;AiB53BM;EACE,YAAA;AjB83BR;AiB33BI;EACE;IACE,kBAAA;EjB63BN;EiB53BM;IACE,eAAA;EjB83BR;AACF;AiB33BI;EACE;IACE,kBAAA;EjB63BN;EiB53BM;IACE,eAAA;EjB83BR;AACF;AiB33BI;EACE;IACE,kBAAA;EjB63BN;EiB53BM;IACE,eAAA;EjB83BR;AACF;AiB13BE;EACE;IACE,kBAAA;EjB43BJ;AACF;;AkBr/BI;EACE,8BAAA;AlBw/BN;AkBt/BI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AlBw/BN;AkBt/BI;EACE,eAAA;AlBw/BN;AkBt/BI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AlBw/BN;AkBr/BE;EACE,gBAAA;AlBu/BJ;AkBr/BE;EACE,aAAA;AlBu/BJ;AkBt/BI;EACE,aAAA;AlBw/BN;AkBt/BI;EACE,UAAA;AlBw/BN;AkBv/BM;EACE,gBAAA;AlBy/BR;AkBr/BU;EACE,eAAA;AlBu/BZ;AkBl/BI;EACE,aAAA;EACA,aAAA;EACA,mBAAA;AlBo/BN;AkBl/BM;EACE,YAAA;EACA,kBAAA;AlBo/BR;;AkB9+BA;EACE,kBAAA;AlBi/BF;AkBh/BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AlBk/BJ;AkBj/BI;EACE,iBAAA;AlBm/BN;AkBj/BI;EACE,YAAA;AlBm/BN;AkBh/BE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AlBk/BJ;AkBj/BI;EACE,iBAAA;AlBm/BN;AkBj/BI;EACE,aAAA;AlBm/BN;;AkB/+BA;EACE,iBAAA;AlBk/BF;;AmBxlCA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gDAAA;AnB2lCJ;AmB1lCI;EACI,aAAA;AnB4lCR;;AoBhmCY;EACI,0BAAA;ApBmmChB;AoBjmCY;EACI,sCAAA;ApBmmChB;AoB/lCY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ApBimChB;AoB/lCY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ApBimChB;AoB7lCI;EACI,0BAAA;ApB+lCR;AoB7lCQ;EACI,gBAAA;ApB+lCZ;AoB5lCoB;EACI,iBAAA;EACA,gBAAA;ApB8lCxB;AoB1lCoB;EACI,iBAAA;ApB4lCxB;AoB1lCoB;EACI,aAAA;EACA,mBAAA;ApB4lCxB;AoB3lCwB;EACI,kBAAA;ApB6lC5B;AoB1lCoB;EACI,aAAA;EACA,mBAAA;EACA,kDnB5BR;EmB6BQ,mBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;ApB4lCxB;AoB1lCwB;EACI,eAAA;EACA,oBAAA;EACA,YAAA;ApB4lC5B;AoB1lCwB;EACI,oBAAA;EACA,YAAA;ApB4lC5B;AoBrlCY;EACI,0BAAA;ApBulChB;AoBtlCgB;EACI,0BAAA;ApBwlCpB;;AoBjlCA;EACI,WAAA;ApBolCJ;AoBnlCI;EACI,WAAA;EACA,mBAAA;ApBqlCR;AoBnlCI;EACI,WAAA;ApBqlCR;AoBplCQ;EACI,WAAA;EACA,iBAAA;ApBslCZ;AoBrlCY;EACI,oBAAA;ApBulChB;;AqB5rBI;EACI,2BAAA;ArB+rBR;;AqB3rBA;EACI,wBAAA;ArB8rBJ;AqB5rBI;;EAEI,iBAAA;EACA,gBAAA;EAEA,cAAA;ArB6rBR;;AqBzrBA;EACI,iBAAA;ArB4rBJ;;AqBzrBA;EACI,2CAAA;ArB4rBJ;AqB1rBI;EACI,eAAA;ArB4rBR;AqB1rBQ;EACI,eAAA;EACA,gBAAA;ArB4rBZ;AqBzrBQ;EACI,iBAAA;ArB2rBZ;AqBvrBI;EACI,0BAAA;ArByrBR;AqBtrBQ;EACI,eAAA;ArBwrBZ;AqBrrBQ;EACI,gBAAA;ArBurBZ;AqBnrBoB;EACI,iBAAA;EACA,gBAAA;ArBqrBxB;AqBhrBoB;EACI,iBAAA;ArBkrBxB;AqB/qBoB;EACI,aAAA;EACA,mBAAA;ArBirBxB;AqB/qBwB;EACI,kBAAA;ArBirB5B;AqB7qBoB;EACI,aAAA;EACA,mBAAA;EACA,kDpBziBR;EoB0iBQ,mBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;ArB+qBxB;AqB7qBwB;EACI,eAAA;EACA,oBAAA;EACA,YAAA;ArB+qB5B;AqB5qBwB;EACI,oBAAA;EACA,YAAA;ArB8qB5B;AqBtqBI;EACI,iCAAA;ArBwqBR;AqBtqBQ;EACI,iBAAA;ArBwqBZ;AqBrqBQ;EACI,eAAA;EACA,gBAAA;ArBuqBZ;AqBpqBQ;EACI,aAAA;ArBsqBZ;AqBnqBQ;EACI,UAAA;ArBqqBZ;AqBnqBY;EACI,iBAAA;ArBqqBhB;AqBlqBY;EACI,eAAA;ArBoqBhB;AqBhqBgB;EACI,YAAA;ArBkqBpB;AqB7pBQ;EACI,WAAA;EACA,mBAAA;ArB+pBZ;AqB7pBY;EACI,iBAAA;ArB+pBhB;AqB7pBgB;EACI,aAAA;ArB+pBpB;AqB3pBY;EACI,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,0CAAA;EACA,mBAAA;ArB6pBhB;AqB3pBgB;EACI,iBAAA;EACA,uCpBrnBJ;ADkxChB;AqB1pBgB;EACI,aAAA;EACA,8BAAA;ArB4pBpB;AqB1pBoB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;ArB4pBxB;AqB1pBwB;EACI,YAAA;EACA,kBAAA;ArB4pB5B;AqBvpBgB;EACI,iBAAA;ArBypBpB;AqBvpBoB;EACI,kBAAA;ArBypBxB;AqBtpBoB;EACI;IACI,mBAAA;ErBwpB1B;AACF;AqBppBgB;EACI,yBAAA;ArBspBpB;AqB9oBY;EACI,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ArBgpBhB;AqB9oBgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;ArBgpBpB;AqB/oBoB;EACI,eAAA;EACA,eAAA;EACA,yBAAA;ArBipBxB;AqB9oBoB;EACI,iBAAA;EACA,gBAAA;ArBgpBxB;AqB7oBoB;EACI,WAAA;EACA,iBAAA;EACA,cAAA;ArB+oBxB;AqB5oBoB;EACI,YAAA;EACA,YAAA;ArB8oBxB;AqBzoBY;EACI,gCAAA;ArB2oBhB;AqBzoBgB;EACI,gCAAA;ArB2oBpB;AqBtoBQ;EACI,WAAA;ArBwoBZ;AqBnoBI;EACI;IACI,sBAAA;ErBqoBV;EqBnoBU;IACI,cAAA;IACA,gBAAA;ErBqoBd;EqBnoBc;IACI,WAAA;ErBqoBlB;AACF;AqBhoBI;EACI;IACI,cAAA;IACA,gBAAA;IACA,eAAA;ErBkoBV;EqBhoBU;IACI,WAAA;ErBkoBd;AACF;AqB9nBI;EACI,aAAA;ArBgoBR;AqB7nBI;EACI,oBAAA;ArB+nBR;AqB5nBI;EACI,sBAAA;EACA,mBAAA;EACA,kBAAA;ArB8nBR;AqB1nBQ;EACI,WAAA;ArB4nBZ;AqBxnBoB;EACI,mBAAA;ArB0nBxB;AqBnnBI;EAEI,kBAAA;ArBonBR;AqBjnBY;EACI,aAAA;ArBmnBhB;AqBjnBgB;EACI,YAAA;ArBmnBpB;AqB9mBQ;EAEI,cAAA;EACA,kBAAA;ArB+mBZ;AqB7mBY;EACI,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;ArB+mBhB;AqB5mBY;EACI,iBAAA;ArB8mBhB;AqB5mBgB;EACI,WAAA;ArB8mBpB;AqB1mBY;EACI,cAAA;ArB4mBhB;AqBpmBQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;ArBsmBZ;AqBnmBgB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;ArBqmBpB;AqBnmBoB;EACI,UAAA;ArBqmBxB;AqBjmBgB;EACI,iBAAA;EACA,YAAA;ArBmmBpB;AqB/lBY;EACI,WAAA;EA6BA,aAAA;EACA,mBAAA;ArBqkBhB;AqBjmBgB;EACI,WAAA;EACA,aAAA;EACA,kBAAA;ArBmmBpB;AqBjmBoB;EACI,gCAAA;ArBmmBxB;AqBhmBoB;EACI,gCAAA;ArBkmBxB;AqB9lBgB;EACI,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ArBgmBpB;AqB1lBgB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;ArB4lBpB;AqBzlBgB;EACI,WAAA;ArB2lBpB;AqBvlBY;EACI,kBAAA;ArBylBhB;AqBvlBgB;EACI,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ArBylBpB;AqBrlBgB;EAEI,aAAA;EAEA,8BAAA;ArBqlBpB;AqBjlBgB;EACI,iBAAA;ArBmlBpB;AqB9kBQ;EACI,iBAAA;ArBglBZ;AqB7kBQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;ArB+kBZ;AqB3kBI;EACI,gDAAA;ArB6kBR;AqB3kBQ;EACI,eAAA;EACA,aAAA;EACA,oBAAA;ArB6kBZ;AqB3kBY;EACI,iBAAA;ArB6kBhB;;AqBvkBA;EACI,UAAA;EACA,iBAAA;EACA,gBAAA;ArB0kBJ;AqBxkBI;EACI,gBAAA;ArB0kBR;;AqBrkBI;EACI,YAAA;ArBwkBR;AqBtkBQ;EACI,WAAA;ArBwkBZ;AqBrkBgB;EACI,qBAAA;ArBukBpB;AqBpkBgB;EACI,UAAA;ArBskBpB;;AsBviDA;EACI,gBAAA;AtB0iDJ;AsBviDY;EACI,WAAA;AtByiDhB;AsBxiDgB;EACI,WAAA;AtB0iDpB;;AsBniDA;EACI,oBAAA;AtBsiDJ;AsBpiDI;EACI,eAAA;EACA,gBAAA;AtBsiDR;AsBniDI;EACI,iBAAA;AtBqiDR;;AsBjiDA;EACI;IACI,WAAA;IACA,oBAAA;EtBoiDN;AACF;AsBjiDA;EACI;IACI,WAAA;IACA,oBAAA;EtBmiDN;AACF;AsBhiDA;EACI;IACI,WAAA;IACA,2BAAA;EtBkiDN;AACF;AsBhiDA;EACI;IACI,WAAA;IACA,2BAAA;EtBkiDN;AACF;AsBhiDA;EACI;IACI,2BAAA;EtBkiDN;AACF","sourcesContent":[".no-box-shadow {\n    box-shadow: none !important;\n}\n\n.container {\n    // padding-top: 1rem;\n}\n\n.center {\n    margin: auto;\n    width: 50%;\n    padding: 10px;\n    text-align: center;\n}\n\n.MuiDrawer-paper {\n    background-color: $primary-main !important;\n    // font-size: 1.5rem;\n    span, p, svg {\n        color: white;\n    }\n}\n\n.description {\n    color: rgba(0,0,0,0.5);\n}\n\n.content-container {\n    padding: 1rem 5rem;\n    .divider {\n        margin-top: 1rem;\n    }\n\n    .main-content-wrapper {\n        padding: 3rem 0;\n    }\n}","@use \"~sass-rem\" as rem;\n// or @use \"~sass-rem\" as rem;\n// or @use '../node_modules/sass-rem' as rem;\n\n@import './scss/font.scss';\n@import './scss/colors.scss';\n@import './scss/common.scss';\n\nhtml {\n  font-size: rem.convert(20px); // Simple\n  // padding: rem.convert(5px 10px); // Multiple values\n  // border-bottom: rem.convert(1px solid black); // Multiple mixed values\n  // box-shadow: rem.convert(0 0 2px #ccc, inset 0 0 5px #eee); // Comma-separated values\n  // Multiple properties\n  // @include rem.convert((\n  //   margin: 10px 5px,\n  //   text-shadow: (1px 1px #eee, -1px -1px #eee) // Parentheses needed because of comma\n  // ));\n\n  // background-color: rgba(235, 230, 230);\n\n  span {\n    color: $text-primary;\n  }\n\n  span, p, input, h1, h2, h3, h4, h5, h6, button {\n    @include mulish;\n    // font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n  }\n\n  a, button {\n    cursor: pointer;\n  }\n\n  // span {\n  //   color: \"#ffffff\";\n  // }\n\n  // span [class$=\"secondary\"] {\n  //   // color: $text-secondary;\n  // }\n\n  .container {\n    padding: rem.convert(5px 10px);\n  }\n\n  input[type=number]::-webkit-inner-spin-button, \n  input[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none; \n  }\n\n  input[type=number] {\n    -moz-appearance: textfield;\n  }\n}\n\n@media (max-width:480px) {\n  html {\n    font-size: rem.convert(18px);\n  }\n}\n\n@media (min-width:480px) and (max-width: 600px) {\n  html {\n    font-size: rem.convert(18px);\n  }\n}\n\n@media (min-width:600px) and (max-width: 800px) {\n  html {\n    font-size: rem.convert(18px);\n  }\n}\n\n@media (min-width:800px) and (max-width: 1000px) {\n  html {\n    font-size: rem.convert(18px);\n  }\n}\n\n@import '../containers/common.scss';\n@import '../components/components.scss';\n\n@import '../containers/Layouts/AuthLayout/Auth.scss';\n@import '../containers/Layouts/DashboardLayout/Dashboard.scss';\n@import '../containers/Layouts/SetupLayout/SetupLayout.scss';\n\n@import '../views/Landing/landing.scss';\n@import '../views/Dashboard/Dashboard.scss';\n@import '../views/InitialSetup/InitialSetup.scss';\n","$bg-theme: #282c34;\n$highlight: #e31b6d;\n$title-theme: #444649;\n$theme: #04c2c9;\n\n// MUI Color Palette \n$primary-light: var(--mui-palette-primary-light);\n$primary-main: var(--mui-palette-primary-main);\n$primary-dark: var(--mui-palette-primary-dark);\n$secondary-light: var(--mui-palette-secondary-light);\n$secondary-main: var(--mui-palette-secondary-main);\n$secondary-dark: var(--mui-palette-secondary-dark);\n$error-light: var(--mui-palette-error-light);\n$error-main: var(--mui-palette-error-main);\n$error-dark: var(--mui-palette-error-dark);\n$warning-light: var(--mui-palette-warning-light);\n$warning-main: var(--mui-palette-warning-main);\n$warning-dark: var(--mui-palette-warning-dark);\n$info-light: var(--mui-palette-info-light);\n$info-main: var(--mui-palette-info-main);\n$info-dark: var(--mui-palette-info-dark);\n$success-light: var(--mui-palette-success-light);\n$success-main: var(--mui-palette-success-main);\n$success-dark: var(--mui-palette-success-dark);\n\n$text-primary: \"#ffffff\";\n\n\n","// Raleway + Roboto\n@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,800;1,300;1,400;1,500;1,600;1,800&family=Roboto&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n$Raleway: 'Raleway', sans-serif;\n$Roboto: 'Roboto', sans-serif;\n$Mulish: 'Mulish', sans-serif;\n$Montserrat: 'Montserrat', sans-serif;\n\n@mixin montserrat-reg {\n    font-family: $Raleway;\n    font-weight: 400;\n}\n\n@mixin raleway {\n    font-family: $Raleway;\n    font-weight: 400;\n}\n\n@mixin raleway-bold {\n    font-family: $Raleway;\n    font-weight: 600;\n}\n\n@mixin Roboto {\n    font-family: $Roboto;\n}\n\n@mixin mulish-light {\n    font-family: $Mulish;\n    font-weight: 200;\n}\n\n@mixin mulish {\n    font-family: $Mulish !important;\n    font-weight: 400;\n}\n\n@mixin mulish-bold {\n    font-family: $Mulish;\n    font-weight: 600;\n}\n\n@mixin mulish-xbold {\n    font-family: $Mulish;\n    font-weight: 800;\n}\n\n@mixin mulish-italic {\n    font-family: $Mulish;\n    font-weight: 800;\n    font-style: italic;\n}",".transparent-bar {\n    p, span, button {\n        color: black;\n    }\n    .MuiToolbar-root {\n        .MuiBox-root {\n            margin-left: 15px;\n            button {\n                margin-top: 20px;\n                margin-bottom: 20px;\n                padding: 6px 16px;\n                text-transform: capitalize;\n                font-weight: 600;\n            }\n        }\n    }\n    .logo-wrapper {\n        height: 100%;\n        margin-right: 1rem;\n        img {\n            // height: 1.5rem;\n            height: 3rem;\n            margin-top: 0.5rem;\n        }\n    }\n\n    .action-btn {\n        color: white;\n    }\n}\n\n.search-navbar {\n    padding: 0.3rem 3rem;\n    .MuiToolbar-root {\n        align-items: center;\n    }\n\n    .logo-wrapper {\n        height: 100%;\n        margin-right: 1rem;\n        img {\n            height: 1.5rem;\n        }\n    }\n\n    .search-bar {\n        width: 40% !important;\n        align-items: center;\n\n        .search-input {\n            width: 100%;\n            input {\n                width: 100%;\n            }\n        }\n    }\n    @media only screen and (max-width: 899px) {\n        .search-bar {\n            width: 100% !important;\n        }\n    }\n    .logo-title {\n        font-size: 1.5rem;\n    }\n}\n\n.drawer-wrapper-right {\n    .MuiDrawer-paper {\n        background-color: white !important;\n        .action-wrapper {\n            display: flex;\n            justify-content: center;\n        }\n    }\n    span {\n        color: black;\n    }\n}\n\n@media (min-width: 0px) and (orientation: landscape) {\n    .MuiToolbar-root {\n        min-height: 64px !important;\n    }\n}\n\n@media only screen and (max-width: 899px) {\n    .search-navbar {\n        padding: 0.3rem 1rem;\n    }\n}",".seconday-appbar {\n    background-color: $secondary-main;\n    padding: 0.5rem 4rem !important;\n    font-size: 0;\n    display: flex;\n\n    span, p, button {\n        // color: white;\n        // font-size: 1.2rem;\n        text-transform: none;\n    }\n\n    svg {\n        color: white;\n    }\n\n    .MuiButtonBase-root {\n        &:not(:last-child) {\n            margin-right: 1rem;\n        }\n    }\n}\n\n@media only screen and (max-width: 600px) {\n    .seconday-appbar {\n        // width: 100% !important;\n        padding: 0 !important;\n        display: block;\n    }\n}\n\n.drawer-wrapper {\n    .MuiDrawer-paper {\n        height: 100% !important;\n    }\n}",".side-filter-wrapper {\n    // border: 2px solid red;\n\n    .filter-wrapper {\n        // border: 1px solid green;\n        width: 80%;\n        .title {\n            font-size: 1.4rem;\n        }\n        .MuiList-root, .MuiFormGroup-root {\n            padding-top: 1.2rem;\n            .MuiListItem-root, .MuiFormControlLabel-root {\n                padding: 0;\n                &:hover {\n                    cursor: pointer;\n                }\n                .MuiButtonBase-root {\n                    padding: 0.4rem 0.6rem 0.4rem 0.4rem;\n                    svg {\n                        width: 1rem;\n                        height: 1rem;\n                        color: rgba(0,0,0,0.5);\n                    }\n                }\n            }\n        }\n        .MuiSlider-root {\n            padding-top: 3rem;\n            width: 90%;\n        }\n    }\n}\n.custom-swipeable-drawer {\n    // border: 2px solid red;\n    .box-wrapper {\n        // border: 2px solid green;\n        display: flex;\n        justify-content: center;\n        p {\n            font-size: 1.5rem;\n            color: rgba(0,0,0,0.5);\n        }\n    }\n    .box-warpper-content {\n        p, ul, span {\n            color: rgba(0,0,0,0.5);\n        }\n    }\n}",".footer-section {\n    padding: 5rem;\n    background: $secondary-main;\n\n    span, p, button, svg, a {\n        color: white;\n    }\n\n    .logo {\n        display: flex;\n        padding: 0.2rem;\n        align-items: center;\n    }\n\n    .footer-content {\n        padding: 2rem 0;\n        .description {\n            font-size: 1rem;\n            line-height: 1.5;\n        }\n    }\n}",".dialog-title {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding-top: 1rem;\n\n    .logo-wrapper {\n        img {\n            height: 2.2rem;\n        }\n    }\n    \n    .description {\n        font-size: 0.8rem;\n    }\n}\n\n.dialog-body {\n    padding: 2rem;\n\n    .form-wrapper {\n        display: block;\n    }\n}\n\n.MuiDialogActions-root {\n    padding: 0 2rem !important;\n\n    button {\n        width: 100%;\n    }\n}\n\n.dialog-footer {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    padding: 1rem 0 1.5rem 0;\n}\n\n.form-dialog-wrapper {\n    .dialog-action {\n        padding: 1rem !important;\n    }\n    .title-text {\n        font-size: 1rem;\n    }\n    .title-sec-text {\n        font-size: 0.8rem;\n    }\n    .form-wrapper {\n        display: flex;\n        flex-direction: column;\n        .form-label {\n            .label-text {\n                font-size: 0.9rem;\n                font-weight: 600;\n                color: black;\n            }\n            .label-sec-text {\n                font-size: 0.8rem;\n                color: black;\n            }\n        }\n        .form-control {\n            // width: 100%;\n            .editor {\n                width: 100%;\n                height: 120px;\n                margin-top: 0.5rem;\n                \n                .ql-toolbar {\n                    border-radius: 0.5rem 0.5rem 0 0;\n                }\n                .ql-container {\n                    border-radius: 0 0 0.5rem 0.5rem;\n                }\n            }\n            display: flex;\n            flex-direction: row;\n            .divider-text {\n                padding: 0.5rem;\n                display: flex;\n                align-items: center;\n            }\n        }\n    }\n}",".image-uploader-wrapper {\n    width: 100%;\n    margin-top: 0.5rem;\n    .preview-container {\n        display: flex;\n        flex-direction: row;\n    }\n    .uploader-wrapper {\n        border: 1px dashed $primary-main;\n        padding: 0.5rem;\n        border-radius: 0.5rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        svg {\n            font-size: 3rem;\n            margin-bottom: 0.4rem;\n        }\n        .uploader-text {\n            font-size: 0.8rem;\n            margin-bottom: 0.2rem;\n        }\n        .uploader-sec-text {\n            font-size: 0.7rem;\n        }\n        .image-list-wrapper {\n            width: 100%;\n            min-height: 150px;\n            display: flex;\n            align-items: center;\n            // display: grid;\n            // grid-template-columns: auto auto auto;\n            // grid-gap: 1rem;\n            // align-items: center;\n            // justify-content: center;\n\n            .preview-wrapper {\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n            }\n            .image-preview-wrapper {\n                // display: flex;\n                padding: 0.5rem;\n                margin-bottom: 0.5rem;\n                display: grid;\n                grid-template-columns: auto auto auto;\n                grid-gap: 1rem;\n                .img-wrapper {\n                    display: flex;\n                    flex-direction: column;\n                    .preview-text {\n                        font-size: 0.7rem;\n                        .span-hidden {\n                            visibility: hidden;\n                            font-size: 0.7rem;\n                        }\n                    }\n                    .img-container {\n                        // display: contents;\n                        min-width: 120px;\n                        width: 100%;\n                        min-height: 100px;\n                        display: flex;\n                        justify-content: center;\n                        img {\n                            position: relative;\n                            height: 80px;\n                            box-shadow: var(--mui-shadows-2);\n                        }\n                        .cancel-btn {\n                            z-index: 2;\n                            padding: 0;\n                            // top: 0rem;\n                            // left: 0rem;\n                            // right: 0rem;\n                            position: absolute;\n                            svg {\n                                font-size: 1.2rem;\n                                margin-bottom: 0;\n                            }\n                            // position: absolute;\n                            // top: 50%;\n                            // left: 50%;\n                            transform: translate(120%, -50%);\n                        }\n                    }\n                }\n            }\n        }\n        .input-wrapper {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            width: 100%;\n        }\n        .add-btn-wrapper {\n            display: flex;\n            justify-content: center;\n            width: 40%;\n            svg {\n                color: $secondary-main;\n                font-size: 1.2rem;\n                margin-bottom: 0;\n            }\n        }\n    }\n}",".carousel-wrapper {\n    width: 100%;\n\n    .splide {\n        width: 100%;\n        margin: auto;\n        .splide__slide {\n            // padding: 1rem;\n        }\n    }\n\n    .slider-card {\n        // width: 95%;\n        // padding: 0.5rem;\n\n        .content-card {\n            box-shadow: var(--mui-shadows-4) !important;\n        }\n\n        .MuiCardMedia-root {\n            // padding: 1rem;\n            background-position: center;\n            background-size: contain;\n        }\n\n        .MuiCardContent-root {\n            // padding: 0.5rem 2rem !important;\n        }\n\n        .MuiCardActions-root {\n            padding: 0 2rem 1rem 2rem !important;\n        }\n    }\n\n    @media (max-width:800px) {\n        .splide {\n            width: 85%;\n        }\n    }\n}",".bottom-nav-wrapper {\n    .bottom-nav-toolbar {\n        .fab-wrapper {\n            .img-wrapper {\n                height: 100%;\n                img {\n                    margin: 0 0 0 -0.35rem;\n                    height: 100%;\n                }\n            }\n        }\n        .toolbar-item {\n            padding: 0.2rem;\n            .MuiListItemButton-root {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n            }\n            .toolbar-icon {\n                color: white;\n                min-width: unset;\n            }\n            .toolbar-text {\n\n            }\n        }\n        .toolbar-divider {\n            border: 0.05rem solid;\n            border-color: rgba(255, 255, 255, 0.5);\n        }\n    }\n}\n\n.drawer-list-wrapper {\n    width: 360px !important;\n}","@import \"./Dialog/dialog.scss\";\n@import \"./Inputs/ImageUploader/ImageUploader.scss\";\n@import \"./Carousel/Carousel.scss\";\n@import \"./Navigation/Navigation.scss\";\n\n.mobile-input-wrapper {\n    // border: 1px solid blue;\n    display: flex;\n    .MuiFormLabel-root {\n        // display: none;\n    }\n    .select-input {\n        width: 140px;\n        padding: 8.5px 0px;\n    }\n    .MuiInputBase-root {\n        .MuiSelect-select {\n            // padding: 8.5px 14px;\n            // border: 2px solid red;\n        }\n    }\n}\n.dial-code-wrapper {\n    display: flex;\n    align-items: center;\n    img {\n        height: 1rem;\n        margin-right: 0.5rem;\n    }\n}\n.alert-wrapper {\n    position: absolute;\n    display: block;\n    z-index: 3;\n    right: 1.5rem; /*newly added*/\n    top: 1rem;\n    // width: 90%;\n}",".auth-layout-wrapper {\n  padding: 65px 50px;\n  min-height: 100vh;\n  // left:50%;\n  // top:50%;\n  // margin-left:-250px;\n  // margin-top:-250px;\n  background-image: linear-gradient(to bottom right, white 50%, $primary-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .auth-layout-container {\n    height: fit-content;\n    min-height: 90vh;\n  }\n\n  .logo-wrapper {\n    display: flex;\n    align-items: center;\n    .img-wrapper {\n      margin-right: 1rem;\n      img {\n        height: 5rem;\n      }\n    }\n  }\n\n  .content-wrapper {\n    padding: 3rem 3rem 3rem 0;\n    .title {\n      font-size: 2rem;\n      font-weight: 600;\n    }\n    .description {\n      font-size: 1rem;\n    }\n  }\n\n  .svg-wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    margin-top: -5rem;\n    svg {\n      height: 25rem;\n    }\n  }\n\n  .login-wrapper {\n    // border: 1px solid red;\n    .card-wrapper {\n      padding: 1.5rem 2rem;\n      // border: 2px solid;\n      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.75);\n      .form-label {\n        font-weight: 600;\n      }\n      .form-container {\n        padding: 1rem 0 0 0;\n        .form-wrapper {\n          padding-bottom: 0.4rem;\n          width: 100%;\n          .button-wrapper {\n            padding-top: 0.6rem;\n            width: 100%;\n            button {\n              width: 100%;\n            }\n          }\n          .link-wrapper {\n            padding-top: 0.6rem;\n            span {\n              font-size: 0.8rem;\n              color: #688ad5;\n            }\n            a {\n              text-decoration: none;\n            }\n          }\n        }\n        .select-wrapper {\n          .error-text {\n            color: var(--mui-palette-error-main);\n            font-weight: 400;\n            font-size: 0.75rem;\n            line-height: 1.66;\n            letter-spacing: 0.03333em;\n            text-align: left;\n            margin-top: 4px;\n            margin-right: 14px;\n            margin-bottom: 0;\n            margin-left: 14px;\n          }\n        }\n      }\n    }\n    .sec-card-wrapper {\n      padding: 1.5rem 2rem;\n      background-color: rgba(0, 0, 0, 0.03);\n      .button-wrapper {\n        padding: 0.5rem 0;\n        width: 100%;\n        a {\n          border: 2px solid black;\n          color: black;\n          width: 100%;\n          background-color: white;\n        }\n      }\n      .text-wrapper {\n        span {\n          font-size: 0.7rem;\n        }\n        a {\n          color: #cd1479;\n        }\n      }\n    }\n  }\n}\n\n.condition-dialog-wrapper {\n  .MuiDialog-container {\n    .MuiDialog-paper {\n      max-width: 900px;\n      .policy-wrapper {\n        line-height: 1.2;\n      }\n      .dialog-action {\n        padding: 0.5rem 1rem !important;\n        button {\n          width: fit-content;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .auth-layout-wrapper {\n    padding: 10px 50px;\n    .content-wrapper {\n      padding: 3rem 0 3rem 0;\n    }\n    .svg-wrapper {\n      svg {\n        width: 100%;\n        height: unset;\n      }\n    }\n  }\n}\n\n@media (min-width: 480px) and (max-width: 600px) {\n  .auth-layout-wrapper {\n    padding: 15px 80px;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 800px) {\n  .auth-layout-wrapper {\n    padding: 40px 50px;\n  }\n}\n@media (min-width: 800px) and (max-width: 1200px) {\n  .auth-layout-wrapper {\n    padding: 40px 50px;\n  }\n  .signin__leftimg {\n    width: 40%;\n  }\n  .signin__right {\n    width: 60%;\n  }\n}\n@media (min-width: 1200px) and (max-width: 1500px) {\n  .auth-layout-wrapper {\n    padding: 65px 50px;\n  }\n  .signin__leftimg {\n    width: 40%;\n  }\n  .signin__right {\n    width: 60%;\n  }\n  @media (min-width: 1500px) and (max-width: 1900px) {\n    .signin__right__top {\n      width: 100%;\n    }\n    .signin__leftimg {\n      width: 40%;\n    }\n    .signin__right {\n      width: 60%;\n    }\n  }\n}\n",".sidenav-drawer {\n    .MuiToolbar-root {\n        .logo-wrapper {\n            display: flex;\n            align-items: center;\n            .img-wrapper {\n                height: 100%;\n                margin-right: 1rem;\n                img {\n                    // height: 1.5rem;\n                    height: 3rem;\n                    margin-top: 0.5rem;                \n                }\n            }\n        }\n    }\n    .MuiDrawer-paper {\n        .list-wrapper {\n            padding-top: 2rem;\n            .MuiListItem-root, .MuiListItemButton-root {\n                padding-right: 2rem;\n                svg, span {\n                    color: var(--mui-palette-custom-main);\n                    font-size: 0.9rem;\n                }\n                .MuiListItemIcon-root {\n                    min-width: 45px;\n                }\n                .MuiListItemText-root {\n                    \n                }\n            }\n        }\n    }\n}","// @import '../../SideNavigation/SideNavigation.scss';\n\n// .dashboard-wrapper {\n//     .right-content-wrapper {\n//         background-image: url('../../../assets/images/wallpaper1.png');\n//         background-repeat: no-repeat;\n//         background-size: contain;\n//         min-height: 100vh;\n//         width: 100%;\n//         .content-wrapper {\n//             padding: 0rem 2rem;\n//         }\n//         .action-item-nav-btn {\n//             button {\n//                 color: white;\n//             }\n//             .nav-icon-btn {\n//                 width: 8rem;\n//                 .nav-icon-svg {\n//                     width: 1.5rem;\n//                     &:hover {\n//                         font-size: 1.2rem;\n//                     }\n//                 }\n//             }\n//         }\n//     }\n\n//     @media (max-width: 1200px) {\n//         .empty-appbar {\n//             top: auto;\n//             bottom: 0;\n//             height: 6rem;\n//             position: relative;\n//             z-index: 0;\n//             box-shadow: unset; \n//         }\n//     }\n// }\n\n\n@import '../../SideNavigation/SideNavigation.scss';\n\n.dashboard-wrapper {\n    .right-content-wrapper {\n        background-image: url('../../../assets/images/wallpaper2.png');\n        background-repeat: no-repeat;\n        background-size: contain;\n        min-height: 100vh;\n        width: 100%;\n        .content-wrapper {\n            padding: 0rem 2rem;\n        }\n        .action-item-nav-btn {\n            button {\n                color: white;\n            }\n            .nav-icon-btn {\n                width: 8rem;\n                .nav-icon-svg {\n                    width: 1.5rem;\n                    &:hover {\n                        font-size: 1.2rem;\n                    }\n                }\n            }\n        }\n    }\n\n    @media (max-width: 1200px) {\n        .empty-appbar {\n            top: auto;\n            bottom: 0;\n            height: 6rem;\n            position: relative;\n            z-index: 0;\n            box-shadow: unset; \n        }\n    }\n}\n",".setup-layout-wrapper {\n    padding: 2rem 5rem;\n    min-height: 100vh;\n    background-image: linear-gradient(to bottom right, white 50%, $primary-main);\n    display: flex;\n    // align-items: center;\n\n    .setup-layout-container {\n        height: fit-content;\n    }\n\n    .logo-wrapper {\n        display: flex;\n        align-items: center;\n        .img-wrapper {\n            margin-right: 1rem;\n            img {\n                height: 2.5rem;\n            }\n        }\n    }\n\n    .content-wrapper {\n        padding: 3rem 3rem 3rem 0;\n        .title {\n            font-size: 2.5rem;\n            font-weight: 600;\n        }\n        .description {\n            font-size: 1rem;\n        }\n    }\n\n    .svg-wrapper {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        margin-top: -5rem;\n        svg {\n            height: 25rem;\n        }\n    }\n\n    .login-wrapper {\n        // border: 1px solid red;\n        .card-wrapper {\n            padding: 1.5rem 2rem;\n            // border: 2px solid;\n            box-shadow: 5px 5px 10px 0px rgba(0,0,0,0.75);;\n            .form-label {\n                font-weight: 600;\n            }\n            .form-container {\n                padding: 1rem 0 0 0;\n                .form-wrapper {\n                    padding-bottom: 0.4rem;\n                    .button-wrapper {\n                        padding-top: 0.6rem;\n                        width: 100%;\n                        button {\n                            width: 100%;\n                        }\n                    }\n                    .link-wrapper {\n                        padding-top: 0.6rem;\n                        span {\n                            font-size: 0.8rem;\n                            color: $primary-main;\n                        }\n                    }\n                }\n            }\n        }\n        .sec-card-wrapper {\n            padding: 1.5rem 2rem;\n            background-color: rgba(0,0,0,0.03);\n            .button-wrapper {\n                padding: 0.5rem 0;\n                width: 100%;\n                a {\n                    border: 2px solid black;\n                    color: black;\n                    width: 100%;\n                    background-color: white;\n                }\n            }\n            .text-wrapper {\n                span {\n                    font-size: 0.7rem;\n                }\n            }\n        }\n    }\n}\n\n@media (max-width:480px) {\n    .setup-layout-wrapper {\n        padding: 2rem 3rem;\n    }\n}\n\n@media (min-width:480px) and (max-width: 600px) {\n    .setup-layout-wrapper {\n        padding: 2rem 3rem;\n    }\n}\n\n@media (min-width:600px) and (max-width: 800px) {\n    .setup-layout-wrapper {\n        padding: 2rem 5rem;\n    }\n}\n@media (min-width:800px) and (max-width: 1200px) {\n    .setup-layout-wrapper {\n        padding: 2rem 3rem;\n    }\n}\n@media (min-width:1200px) and (max-width: 1500px) {\n    .setup-layout-wrapper {\n        padding: 2rem 4rem;\n    }\n}",".website-analytics-wrapper {\n  .component-grid {\n    .dashboard-card-wrapper {\n      .content-wrapper {\n        // padding: 1rem 0 !important;\n      }\n      .content-bottom-wrapper {\n        padding: 0 1rem 2rem 1rem !important;\n      }\n    }\n    .list-wrapper {\n      .header-wrapper {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n      }\n    }\n  }\n  .dashboard-table-container {\n    padding: 1rem 0 !important;\n    // border: 2px solid red;\n    .MuiTableContainer-root {\n      box-shadow: none;\n      .MuiTable-root {\n        .MuiTableHead-root {\n          span {\n            font-size: 0.7rem;\n            font-weight: 600;\n          }\n        }\n        .MuiTableBody-root {\n          span {\n            font-size: 0.7rem;\n          }\n          .row-flex {\n            display: flex;\n            align-items: center;\n            .cell-text {\n              margin-right: 3rem;\n            }\n          }\n          .cell-label {\n            display: flex;\n            align-items: center;\n            background-color: $success-light;\n            border-radius: 1rem;\n            padding: 0.3rem;\n            width: fit-content;\n\n            svg {\n              font-size: 1rem;\n              margin-right: 0.3rem;\n              color: white;\n            }\n            span {\n              margin-right: 0.3rem;\n              color: white;\n            }\n          }\n        }\n      }\n    }\n    .rating-wrapper {\n      .MuiRating-root {\n        font-size: 1rem !important;\n        .MuiRating-icon {\n          font-size: 1rem !important;\n        }\n      }\n    }\n  }\n}\n\n.form-grid-container {\n  width: 100%;\n  .form-wrapper {\n    width: 100%;\n    padding: 0 0 1rem 0;\n  }\n  .multi-form-ele {\n    width: 100%;\n    .form-control {\n      width: 100%;\n      padding: 0.3rem 0;\n      .adornment-icon {\n        margin-right: 0.5rem;\n      }\n    }\n  }\n}\n\n@media (min-width: 360px) and (max-width: 900px) {\n  .overlay-wrapper .subscription-card {\n    padding-top: 40%;\n    justify-content: flex-start !important;\n  }\n}\n","@import \"./Pricing.scss\";\n.layout-view {\n  width: 100%;\n  font-size: 2rem;\n  // position: relative;\n  left: 0;\n  top: 0;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n\n  .main-view {\n    flex: 1;\n  }\n\n  .banner-section {\n    width: 100%;\n\n    .banner-content {\n      background-size: cover;\n      background-repeat: no-repeat;\n    }\n    .gradient-content {\n      background-color: #29aecc; /* For browsers that do not support gradients */\n      background-image: linear-gradient(to bottom left, #29aecc, white);\n    }\n    .title-section {\n      padding: 5rem 4rem;\n      height: 100%;\n      .title {\n        font-size: 2.4rem;\n      }\n      .description {\n        font-size: 1.2rem;\n        line-height: 1.5;\n      }\n    }\n  }\n\n  @media (max-width: 1000px) {\n    .banner-section {\n      // background-size: contain;\n    }\n  }\n\n  .draft-section {\n    padding: 3rem;\n\n    .title-section {\n      width: 70%;\n      .description {\n        font-size: 1rem;\n        line-height: 1.5rem;\n      }\n    }\n    .content-section {\n      display: flex;\n      flex-direction: row;\n      padding: 1rem 0;\n\n      .content-card {\n        margin-right: 1rem;\n        width: 25%;\n\n        .MuiCardContent-root {\n          padding: 0;\n        }\n\n        .MuiCardActions-root {\n          padding: 0 0 0.7rem 0;\n          display: block;\n        }\n      }\n    }\n  }\n}\n\n.landing-wrapper {\n  .view-wrapper {\n    padding: 1rem 3rem;\n    .detail-wrapper {\n      padding: 4rem 4rem;\n      display: flex;\n      flex-direction: column;\n      .title {\n        font-size: 4rem;\n        font-weight: 900;\n      }\n      .sec-title {\n        font-size: 1rem;\n      }\n      button {\n        width: 300px;\n      }\n    }\n    @media (max-width: 800px) {\n      .detail-wrapper {\n        padding: 2rem 2rem;\n        .title {\n          font-size: 3rem;\n        }\n      }\n    }\n    @media (min-width: 800px) and (max-width: 1200px) {\n      .detail-wrapper {\n        padding: 4rem 3rem;\n        .title {\n          font-size: 3rem;\n        }\n      }\n    }\n    @media (min-width: 1200px) and (max-width: 1500px) {\n      .detail-wrapper {\n        padding: 4rem 3rem;\n        .title {\n          font-size: 3rem;\n        }\n      }\n    }\n  }\n  @media (max-width: 800px) {\n    .view-wrapper {\n      padding: 1rem 1rem;\n    }\n  }\n}\n",".home-wrapper {\n  .dashboard-card-wrapper {\n    .content-wrapper {\n      padding: 0 0 1rem 0 !important;\n    }\n    .justified-card {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0.7rem 0;\n    }\n    .MuiCardContent-root {\n      padding: 0 1rem;\n    }\n    .justified-center-card {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 0 0 1rem 0;\n    }\n  }\n  .secondary-card {\n    margin-top: 1rem;\n  }\n  .setup-card {\n    padding: 1rem;\n    .step-form-container {\n      padding: 2rem;\n    }\n    .stepper-wrapper {\n      padding: 0;\n      .divider {\n        margin: 0.5rem 0;\n      }\n      .checklist-wrapper {\n        .icon-btn-directional {\n          svg {\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n    .action-grid {\n      padding: 1rem;\n      display: flex;\n      align-items: center;\n\n      .logo-image {\n        height: 36px;\n        margin-right: 22px;\n      }\n    }\n  }\n}\n\n.overlay-wrapper {\n  position: relative;\n  .overlay-card {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 999;\n    color: black;\n    background-color: rgba(255, 255, 255, 0.65);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    .statement {\n      font-size: 1.2rem;\n    }\n    .statement-svg {\n      height: 7rem;\n    }\n  }\n  .subscription-card {\n    width: 400px;\n    height: 400px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 899;\n    color: black;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    justify-content: flex-start;\n    padding-top: 10%;\n    align-items: center;\n    flex-direction: column;\n    .statement {\n      font-size: 1.5rem;\n    }\n    .statement-svg {\n      height: 10rem;\n    }\n  }\n}\n.subscription-overlay {\n  min-height: 100vh;\n  // position: fixed;\n}\n",".nan-wrapper {\n    padding: 4rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--mui-palette-custom-main);\n    svg {\n        height: 20rem;\n    }\n}",".website-analytics-wrapper {\n    .component-grid {\n        .dashboard-card-wrapper {\n            .content-wrapper {\n                padding: 1rem 0 !important;\n            }\n            .content-bottom-wrapper {\n                padding: 0 1rem 2.5rem 1rem !important;\n            }\n        }\n        .list-wrapper {\n            .header-wrapper {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n            }\n            .header-wrapper_category {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n            } \n        }\n    }\n    .dashboard-table-container {\n        padding: 1rem 0 !important;\n        // border: 2px solid red;\n        .MuiTableContainer-root {\n            box-shadow: none;\n            .MuiTable-root {\n                .MuiTableHead-root {\n                    span {\n                        font-size: 0.7rem;\n                        font-weight: 600;\n                    }\n                }\n                .MuiTableBody-root {\n                    span {\n                        font-size: 0.7rem;\n                    }\n                    .row-flex {\n                        display: flex;\n                        align-items: center;\n                        .cell-text {\n                            margin-right: 3rem;\n                        }\n                    }\n                    .cell-label {\n                        display: flex;\n                        align-items: center;\n                        background-color: $success-light;\n                        border-radius: 1rem;\n                        padding: 0.3rem;\n                        width: fit-content;\n                        \n                        svg {\n                            font-size: 1rem;\n                            margin-right: 0.3rem;\n                            color: white;\n                        }\n                        span {\n                            margin-right: 0.3rem;\n                            color: white;\n                        }\n                    }\n                }\n            }\n        }\n        .rating-wrapper {\n            .MuiRating-root {\n                font-size: 1rem !important;\n                .MuiRating-icon {\n                    font-size: 1rem !important;\n                }\n            }\n        }\n    }\n}\n\n.form-grid-container {\n    width: 100%;\n    .form-wrapper {\n        width: 100%;\n        padding: 0 0 1rem 0;\n    }\n    .multi-form-ele {\n        width: 100%;\n        .form-control {\n            width: 100%;\n            padding: 0.3rem 0;\n            .adornment-icon {\n                margin-right: 0.5rem;\n            }\n        }\n    }\n}","// .store-analytics-wrapper {\n//     .MuiCardContent-root {\n//         padding: 0 1rem 1.5rem 1rem;\n//     }\n// }\n\n// .breadcrumb-wrapper {\n//     padding: 0.5rem 0 1rem 0;\n\n//     li,\n//     p {\n//         font-size: 1.2rem;\n//         font-weight: 600;\n//         color: rgba(255, 255, 255, 0.8);\n//     }\n// }\n\n// .component-grid {\n//     padding: 0.5rem 0;\n// }\n\n// .dashboard-card-wrapper {\n//     box-shadow: var(--mui-shadows-4) !important;\n\n//     .header-wrapper {\n//         padding: 1rem 0;\n\n//         .header-text {\n//             font-size: 1rem;\n//             font-weight: 600;\n//         }\n\n//         .header-sec-text {\n//             font-size: 0.7rem;\n//         }\n//     }\n\n//     .dashboard-table-container {\n//         padding: 1rem 0 !important;\n\n//         // border: 2px solid red;\n//         .MuiGrid-item {\n//             max-width: 100%;\n//         }\n\n//         .MuiTableContainer-root {\n//             box-shadow: none;\n\n//             .MuiTable-root {\n//                 .MuiTableHead-root {\n//                     span {\n//                         font-size: 0.7rem;\n//                         font-weight: 600;\n//                     }\n//                 }\n\n//                 .MuiTableBody-root {\n//                     span {\n//                         font-size: 0.7rem;\n//                     }\n\n//                     .row-flex {\n//                         display: flex;\n//                         align-items: center;\n\n//                         .cell-text {\n//                             margin-right: 3rem;\n//                         }\n//                     }\n\n//                     .cell-label {\n//                         display: flex;\n//                         align-items: center;\n//                         background-color: $success-light;\n//                         border-radius: 1rem;\n//                         padding: 0.3rem;\n//                         width: fit-content;\n\n//                         svg {\n//                             font-size: 1rem;\n//                             margin-right: 0.3rem;\n//                             color: white;\n//                         }\n\n//                         span {\n//                             margin-right: 0.3rem;\n//                             color: white;\n//                         }\n//                     }\n//                 }\n//             }\n//         }\n//     }\n\n//     .content-wrapper {\n//         padding: 1rem 0 1rem 0 !important;\n\n//         .content-text {\n//             font-size: 0.7rem;\n//         }\n\n//         .figure-text {\n//             font-size: 2rem;\n//             font-weight: 800;\n//         }\n\n//         svg {\n//             height: 10rem;\n//         }\n\n//         .detail-action-wrapper {\n//             width: 40%;\n\n//             .detail-text {\n//                 font-size: 1.4rem;\n//             }\n\n//             .detail-sec-text {\n//                 font-size: 1rem;\n//             }\n\n//             .button-wrapper {\n//                 svg {\n//                     height: 1rem;\n//                 }\n//             }\n//         }\n\n//         .filter-wrapper {\n//             width: 100%;\n//             align-items: center;\n\n//             .select-wrapper {\n//                 padding: 0 0.5rem;\n\n//                 svg {\n//                     height: unset;\n//                 }\n//             }\n\n//             .payment-card {\n//                 width: 100%;\n//                 padding: 1rem 1.5rem;\n//                 border-radius: 0.5rem;\n//                 background-color: rgba(100, 100, 100, 0.1);\n//                 margin-bottom: 1rem;\n\n//                 .label-text {\n//                     font-size: 0.7rem;\n//                     color: $success-light;\n//                 }\n\n//                 .payment-header {\n//                     display: flex;\n//                     justify-content: space-between;\n\n//                     .detail-sec-wrapper {\n//                         display: flex;\n//                         flex-direction: row;\n//                         align-items: center;\n\n//                         .logo-image {\n//                             height: 2rem;\n//                             margin-right: 1rem;\n//                         }\n//                     }\n//                 }\n\n//                 .payment-detail {\n//                     padding: 0.5rem 0;\n\n//                     span {\n//                         font-size: 0.85rem;\n//                     }\n\n//                     @media only screen and (max-width: 500px) {\n//                         .MuiButtonBase-root {\n//                             margin-bottom: 1rem;\n//                         }\n//                     }\n//                 }\n\n//                 .divider {\n//                     margin: 1rem 0 !important;\n//                 }\n//             }\n//         }\n\n//         .plan-wrapper {\n\n//             // border: 2px solid red;\n//             .plan-card-wrapper {\n//                 padding: 1rem 1rem;\n//                 box-shadow: var(--mui-shadows-1);\n//                 display: flex;\n//                 flex-direction: row;\n//                 justify-content: center;\n\n//                 .detail-wrapper {\n//                     display: flex;\n//                     flex-direction: column;\n//                     align-items: center;\n//                     justify-content: center;\n//                     text-align: center;\n//                     min-height: 400px;\n//                     width: 100%;\n//                     .plan-text {\n//                         min-height: 7vh;\n//                         font-size: 1rem;\n//                         text-transform: uppercase;\n//                     }\n\n//                     .plan-sec-text {\n//                         font-size: 0.7rem;\n//                         min-height: 10vh;\n//                     }\n\n//                     .separator {\n//                         width: 3rem;\n//                         border: 1px solid;\n//                         margin: 0.3rem;\n//                     }\n\n//                     img {\n//                         height: 8rem;\n//                         margin: 1rem;\n//                     }\n//                 }\n//             }\n\n//             .selected {\n//                 box-shadow: var(--mui-shadows-6);\n\n//                 button {\n//                     box-shadow: var(--mui-shadows-2);\n//                 }\n//             }\n//         }\n\n//         .status-wrapper {\n//             width: 100%;\n//             // border: 2px solid red;\n//         }\n//     }\n\n//     @media only screen and (max-width: 900px) {\n//         .filter-bar-wrapper {\n//             flex-direction: column;\n\n//             .search-bar {\n//                 margin-left: 0;\n//                 margin-top: 1rem;\n\n//                 .search-input {\n//                     width: 100%;\n//                 }\n//             }\n//         }\n//     }\n\n//     @media only screen and (max-width: 600px) {\n//         .search-bar {\n//             margin-left: 0;\n//             margin-top: 1rem;\n//             margin-right: 0;\n\n//             .search-input {\n//                 width: 100%;\n//             }\n//         }\n//     }\n\n//     .content-flex {\n//         display: flex;\n//     }\n\n//     .content-flex-right {\n//         justify-content: end;\n//     }\n\n//     .content-flex-center {\n//         flex-direction: column;\n//         align-items: center;\n//         text-align: center;\n//     }\n\n//     .date-wrapper {\n//         .MuiStack-root {\n//             width: 100%;\n\n//             .MuiTextField-root {\n//                 .MuiInputBase-root {\n//                     input {\n//                         padding: 8.5px 14px;\n//                     }\n//                 }\n//             }\n//         }\n//     }\n\n//     .dashboard-details-container {\n//         // border: 2px solid red;\n//         padding: 2rem 3rem;\n\n//         .image-grid {\n//             .image-container {\n//                 height: 300px;\n\n//                 img {\n//                     height: 100%;\n//                 }\n//             }\n//         }\n\n//         .order-detail-container {\n//             // border: 1px solid red;\n//             line-height: 2;\n//             padding: 2rem 5rem;\n\n//             .payment-mode-wrapper {\n//                 background: rgba(0, 0, 0, 0.1);\n//                 border-radius: 1rem;\n//                 width: 50%;\n//                 padding: 0.5rem 1rem;\n//                 margin: 0.2rem 0 0.5rem 0;\n//                 display: flex;\n//                 justify-content: space-between;\n//             }\n\n//             .action-wrapper {\n//                 padding-top: 2rem;\n\n//                 button {\n//                     width: 100%;\n//                 }\n//             }\n\n//             .content-divider {\n//                 margin: 1rem 0;\n//             }\n//         }\n//     }\n\n//     .dashboard-form-container {\n\n//         // height: fit-content;\n//         .form-wrapper {\n//             display: flex;\n//             flex-direction: column;\n//             width: 100%;\n\n//             .form-label {\n//                 .label-text {\n//                     font-size: 0.9rem;\n//                     font-weight: 600;\n//                     color: black;\n\n//                     .required {\n//                         color: red;\n//                     }\n//                 }\n\n//                 .label-sec-text {\n//                     font-size: 0.7rem;\n//                     color: black;\n//                 }\n//             }\n\n//             .form-control {\n//                 width: 100%;\n\n//                 .editor {\n//                     width: 100%;\n//                     height: 120px;\n//                     margin-top: 0.5rem;\n\n//                     .ql-toolbar {\n//                         border-radius: 0.5rem 0.5rem 0 0;\n//                     }\n\n//                     .ql-container {\n//                         border-radius: 0 0 0.5rem 0.5rem;\n//                     }\n//                 }\n\n//                 .error-text {\n//                     color: var(--mui-palette-error-main);\n//                     font-weight: 400;\n//                     font-size: 0.75rem;\n//                     line-height: 1.66;\n//                     letter-spacing: 0.03333em;\n//                     text-align: left;\n//                     margin-top: 4px;\n//                     margin-right: 14px;\n//                     margin-bottom: 0;\n//                     margin-left: 14px;\n//                 }\n\n//                 display: flex;\n//                 flex-direction: row;\n\n//                 .divider-text {\n//                     padding: 0.5rem;\n//                     display: flex;\n//                     align-items: center;\n//                 }\n\n//                 .quill-wrapper {\n//                     width: 100%;\n//                 }\n//             }\n\n//             .select-wrapper {\n//                 margin-top: 0.5rem;\n\n//                 .error-text {\n//                     color: var(--mui-palette-error-main);\n//                     font-weight: 400;\n//                     font-size: 0.75rem;\n//                     line-height: 1.66;\n//                     letter-spacing: 0.03333em;\n//                     text-align: left;\n//                     margin-top: 4px;\n//                     margin-right: 14px;\n//                     margin-bottom: 0;\n//                     margin-left: 14px;\n//                 }\n\n\n//                 .whatsapp_switch_container {\n\n//                     display: flex;\n//                     // align-items: first baseline;\n//                     justify-content: space-between;\n\n//                 }\n\n//                 .label-sec-text {\n//                     font-size: 0.7rem;\n//                 }\n//             }\n//         }\n\n//         .multiple-ele {\n//             padding-top: 1rem;\n//         }\n\n//         .toggle-ele {\n//             display: flex;\n//             flex-direction: row;\n//             justify-content: space-between;\n//         }\n//     }\n\n//     .footer-wrapper {\n//         background-color: var(--mui-palette-custom-main);\n\n//         .action-wrapper {\n//             padding: 1rem 0;\n//             display: flex;\n//             justify-content: end;\n\n//             button {\n//                 margin-left: 1rem;\n//             }\n//         }\n//     }\n// }\n\n// .address-wrapper {\n//     width: 90%;\n//     padding: 0.3rem 0;\n//     line-height: 1.5;\n\n//     .content-divider {\n//         margin: 0.5rem 0;\n//     }\n// }\n\n// .credential-dialog {\n//     .MuiDialog-paper {\n//         width: 600px;\n\n//         .credential-wrapper {\n//             width: 100%;\n\n//             .form-wrapper {\n//                 .form-control {\n//                     margin-bottom: 0.4rem;\n//                 }\n\n//                 .required {\n//                     color: red;\n//                 }\n//             }\n//         }\n//     }\n// }\n\n\n.store-analytics-wrapper {\n    .MuiCardContent-root {\n        padding: 0 1rem 1.5rem 1rem;\n    }\n}\n\n.breadcrumb-wrapper {\n    padding: 0.5rem 0 1rem 0;\n\n    li,\n    p {\n        font-size: 1.2rem;\n        font-weight: 600;\n        // color: rgba(255, 255, 255, 0.8);\n        color: 'black';\n    }\n}\n\n.component-grid {\n    padding: 0.5rem 0;\n}\n\n.dashboard-card-wrapper {\n    box-shadow: var(--mui-shadows-4) !important;\n\n    .header-wrapper {\n        padding: 1rem 0;\n\n        .header-text {\n            font-size: 1rem;\n            font-weight: 600;\n        }\n\n        .header-sec-text {\n            font-size: 0.7rem;\n        }\n    }\n\n    .dashboard-table-container {\n        padding: 1rem 0 !important;\n\n        // border: 2px solid red;\n        .MuiGrid-item {\n            max-width: 100%;\n        }\n\n        .MuiTableContainer-root {\n            box-shadow: none;\n\n            .MuiTable-root {\n                .MuiTableHead-root {\n                    span {\n                        font-size: 0.7rem;\n                        font-weight: 600;\n                    }\n                }\n\n                .MuiTableBody-root {\n                    span {\n                        font-size: 0.7rem;\n                    }\n\n                    .row-flex {\n                        display: flex;\n                        align-items: center;\n\n                        .cell-text {\n                            margin-right: 3rem;\n                        }\n                    }\n\n                    .cell-label {\n                        display: flex;\n                        align-items: center;\n                        background-color: $success-light;\n                        border-radius: 1rem;\n                        padding: 0.3rem;\n                        width: fit-content;\n\n                        svg {\n                            font-size: 1rem;\n                            margin-right: 0.3rem;\n                            color: white;\n                        }\n\n                        span {\n                            margin-right: 0.3rem;\n                            color: white;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .content-wrapper {\n        padding: 1rem 0 1rem 0 !important;\n\n        .content-text {\n            font-size: 0.7rem;\n        }\n\n        .figure-text {\n            font-size: 2rem;\n            font-weight: 800;\n        }\n\n        svg {\n            height: 10rem;\n        }\n\n        .detail-action-wrapper {\n            width: 40%;\n\n            .detail-text {\n                font-size: 1.4rem;\n            }\n\n            .detail-sec-text {\n                font-size: 1rem;\n            }\n\n            .button-wrapper {\n                svg {\n                    height: 1rem;\n                }\n            }\n        }\n\n        .filter-wrapper {\n            width: 100%;\n            align-items: center;\n\n            .select-wrapper {\n                padding: 0 0.5rem;\n\n                svg {\n                    height: unset;\n                }\n            }\n\n            .payment-card {\n                width: 100%;\n                padding: 1rem 1.5rem;\n                border-radius: 0.5rem;\n                background-color: rgba(100, 100, 100, 0.1);\n                margin-bottom: 1rem;\n\n                .label-text {\n                    font-size: 0.7rem;\n                    color: $success-light;\n                }\n\n                .payment-header {\n                    display: flex;\n                    justify-content: space-between;\n\n                    .detail-sec-wrapper {\n                        display: flex;\n                        flex-direction: row;\n                        align-items: center;\n\n                        .logo-image {\n                            height: 2rem;\n                            margin-right: 1rem;\n                        }\n                    }\n                }\n\n                .payment-detail {\n                    padding: 0.5rem 0;\n\n                    span {\n                        font-size: 0.85rem;\n                    }\n\n                    @media only screen and (max-width: 500px) {\n                        .MuiButtonBase-root {\n                            margin-bottom: 1rem;\n                        }\n                    }\n                }\n\n                .divider {\n                    margin: 1rem 0 !important;\n                }\n            }\n        }\n\n        .plan-wrapper {\n\n            // border: 2px solid red;\n            .plan-card-wrapper {\n                padding: 1rem 1rem;\n                box-shadow: var(--mui-shadows-1);\n                display: flex;\n                flex-direction: row;\n                justify-content: center;\n\n                .detail-wrapper {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    text-align: center;\n                    min-height: 400px;\n                    width: 100%;\n                    .plan-text {\n                        min-height: 7vh;\n                        font-size: 1rem;\n                        text-transform: uppercase;\n                    }\n\n                    .plan-sec-text {\n                        font-size: 0.7rem;\n                        min-height: 10vh;\n                    }\n\n                    .separator {\n                        width: 3rem;\n                        border: 1px solid;\n                        margin: 0.3rem;\n                    }\n\n                    img {\n                        height: 8rem;\n                        margin: 1rem;\n                    }\n                }\n            }\n\n            .selected {\n                box-shadow: var(--mui-shadows-6);\n\n                button {\n                    box-shadow: var(--mui-shadows-2);\n                }\n            }\n        }\n\n        .status-wrapper {\n            width: 100%;\n            // border: 2px solid red;\n        }\n    }\n\n    @media only screen and (max-width: 900px) {\n        .filter-bar-wrapper {\n            flex-direction: column;\n\n            .search-bar {\n                margin-left: 0;\n                margin-top: 1rem;\n\n                .search-input {\n                    width: 100%;\n                }\n            }\n        }\n    }\n\n    @media only screen and (max-width: 600px) {\n        .search-bar {\n            margin-left: 0;\n            margin-top: 1rem;\n            margin-right: 0;\n\n            .search-input {\n                width: 100%;\n            }\n        }\n    }\n\n    .content-flex {\n        display: flex;\n    }\n\n    .content-flex-right {\n        justify-content: end;\n    }\n\n    .content-flex-center {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .date-wrapper {\n        .MuiStack-root {\n            width: 100%;\n\n            .MuiTextField-root {\n                .MuiInputBase-root {\n                    input {\n                        padding: 8.5px 14px;\n                    }\n                }\n            }\n        }\n    }\n\n    .dashboard-details-container {\n        // border: 2px solid red;\n        padding: 2rem 3rem;\n\n        .image-grid {\n            .image-container {\n                height: 300px;\n\n                img {\n                    height: 100%;\n                }\n            }\n        }\n\n        .order-detail-container {\n            // border: 1px solid red;\n            line-height: 2;\n            padding: 2rem 5rem;\n\n            .payment-mode-wrapper {\n                background: rgba(0, 0, 0, 0.1);\n                border-radius: 1rem;\n                width: 50%;\n                padding: 0.5rem 1rem;\n                margin: 0.2rem 0 0.5rem 0;\n                display: flex;\n                justify-content: space-between;\n            }\n\n            .action-wrapper {\n                padding-top: 2rem;\n\n                button {\n                    width: 100%;\n                }\n            }\n\n            .content-divider {\n                margin: 1rem 0;\n            }\n        }\n    }\n\n    .dashboard-form-container {\n\n        // height: fit-content;\n        .form-wrapper {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n\n            .form-label {\n                .label-text {\n                    font-size: 0.9rem;\n                    font-weight: 600;\n                    color: black;\n\n                    .required {\n                        color: red;\n                    }\n                }\n\n                .label-sec-text {\n                    font-size: 0.7rem;\n                    color: black;\n                }\n            }\n\n            .form-control {\n                width: 100%;\n\n                .editor {\n                    width: 100%;\n                    height: 120px;\n                    margin-top: 0.5rem;\n\n                    .ql-toolbar {\n                        border-radius: 0.5rem 0.5rem 0 0;\n                    }\n\n                    .ql-container {\n                        border-radius: 0 0 0.5rem 0.5rem;\n                    }\n                }\n\n                .error-text {\n                    color: var(--mui-palette-error-main);\n                    font-weight: 400;\n                    font-size: 0.75rem;\n                    line-height: 1.66;\n                    letter-spacing: 0.03333em;\n                    text-align: left;\n                    margin-top: 4px;\n                    margin-right: 14px;\n                    margin-bottom: 0;\n                    margin-left: 14px;\n                }\n\n                display: flex;\n                flex-direction: row;\n\n                .divider-text {\n                    padding: 0.5rem;\n                    display: flex;\n                    align-items: center;\n                }\n\n                .quill-wrapper {\n                    width: 100%;\n                }\n            }\n\n            .select-wrapper {\n                margin-top: 0.5rem;\n\n                .error-text {\n                    color: var(--mui-palette-error-main);\n                    font-weight: 400;\n                    font-size: 0.75rem;\n                    line-height: 1.66;\n                    letter-spacing: 0.03333em;\n                    text-align: left;\n                    margin-top: 4px;\n                    margin-right: 14px;\n                    margin-bottom: 0;\n                    margin-left: 14px;\n                }\n\n\n                .whatsapp_switch_container {\n\n                    display: flex;\n                    // align-items: first baseline;\n                    justify-content: space-between;\n\n                }\n\n                .label-sec-text {\n                    font-size: 0.7rem;\n                }\n            }\n        }\n\n        .multiple-ele {\n            padding-top: 1rem;\n        }\n\n        .toggle-ele {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n        }\n    }\n\n    .footer-wrapper {\n        background-color: var(--mui-palette-custom-main);\n\n        .action-wrapper {\n            padding: 1rem 0;\n            display: flex;\n            justify-content: end;\n\n            button {\n                margin-left: 1rem;\n            }\n        }\n    }\n}\n\n.address-wrapper {\n    width: 90%;\n    padding: 0.3rem 0;\n    line-height: 1.5;\n\n    .content-divider {\n        margin: 0.5rem 0;\n    }\n}\n\n.credential-dialog {\n    .MuiDialog-paper {\n        width: 600px;\n\n        .credential-wrapper {\n            width: 100%;\n\n            .form-wrapper {\n                .form-control {\n                    margin-bottom: 0.4rem;\n                }\n\n                .required {\n                    color: red;\n                }\n            }\n        }\n    }\n}\n",".setup-wrapper {\n    margin-top: 1rem;\n    .component-grid {\n        .list-wrapper {\n            .form-grid-container {\n                width: 100%;\n                .MuiGrid-root {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n.stepper-wrapper {\n    padding: 3rem 1.5rem;\n\n    .title {\n        font-size: 1rem;\n        font-weight: 600;\n    }\n\n    .description {\n        font-size: 0.8rem;\n    }\n}\n\n@media (max-width:480px) {\n    .stepper-wrapper {\n        width: 100%;\n        padding: 3rem 1.5rem;\n    }\n}\n\n@media (min-width:480px) and (max-width: 600px) {\n    .stepper-wrapper {\n        width: 100%;\n        padding: 3rem 1.5rem;\n    }\n}\n\n@media (min-width:600px) and (max-width: 800px) {\n    .stepper-wrapper {\n        width: 100%;\n        padding: 3rem 0 3rem 1.5rem;\n    }\n}\n@media (min-width:800px) and (max-width: 1200px) {\n    .stepper-wrapper {\n        width: 100%;\n        padding: 3rem 0 3rem 1.5rem;\n    }\n}\n@media (min-width:1200px) and (max-width: 1500px) {\n    .stepper-wrapper {\n        padding: 3rem 0 3rem 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
